export const listaStatiNascitaIndir = [
    { optionValue: "AF", optionLabel: 'AF - AFGHANISTAN' },
    { optionValue: "AX", optionLabel: 'AX - ÅLAND ISLANDS' },
    { optionValue: "AL", optionLabel: 'AL - ALBANIA' },
    { optionValue: "DZ", optionLabel: 'DZ - ALGERIA' },
    { optionValue: "AS", optionLabel: 'AS - AMERICAN SAMOA' },
    { optionValue: "AD", optionLabel: 'AD - ANDORRA' },
    { optionValue: "AO", optionLabel: 'AO - ANGOLA' },
    { optionValue: "AI", optionLabel: 'AI - ANGUILLA' },
    { optionValue: "AQ", optionLabel: 'AQ - ANTARCTICA' },
    { optionValue: "AG", optionLabel: 'AG - ANTIGUA AND BARBUDA' },
    { optionValue: "AR", optionLabel: 'AR - ARGENTINA' },
    { optionValue: "AM", optionLabel: 'AM - ARMENIA' },
    { optionValue: "AW", optionLabel: 'AW - ARUBA' },
    { optionValue: "AU", optionLabel: 'AU - AUSTRALIA' },
    { optionValue: "AT", optionLabel: 'AT - AUSTRIA' },
    { optionValue: "AZ", optionLabel: 'AZ - AZERBAIJAN' },
    { optionValue: "BS", optionLabel: 'BS - BAHAMAS' },
    { optionValue: "BH", optionLabel: 'BH - BAHRAIN' },
    { optionValue: "BD", optionLabel: 'BD - BANGLADESH' },
    { optionValue: "BB", optionLabel: 'BB - BARBADOS' },
    { optionValue: "BY", optionLabel: 'BY - BELARUS' },
    { optionValue: "BE", optionLabel: 'BE - BELGIUM' },
    { optionValue: "BZ", optionLabel: 'BZ - BELIZE' },
    { optionValue: "BJ", optionLabel: 'BJ - BENIN' },
    { optionValue: "BM", optionLabel: 'BM - BERMUDA' },
    { optionValue: "BT", optionLabel: 'BT - BHUTAN' },
    { optionValue: "BO", optionLabel: 'BO - BOLIVIA' },
    { optionValue: "BA", optionLabel: 'BA - BOSNIA AND HERZEGOVINA' },
    { optionValue: "BW", optionLabel: 'BW - BOTSWANA' },
    { optionValue: "BV", optionLabel: 'BV - BOUVET ISLAND' },
    { optionValue: "BR", optionLabel: 'BR - BRAZIL' },
    { optionValue: "IO", optionLabel: 'IO - BRITISH INDIAN OCEAN TERRITORY' },
    { optionValue: "BN", optionLabel: 'BN - BRUNEI DARUSSALAM' },
    { optionValue: "BG", optionLabel: 'BG - BULGARIA' },
    { optionValue: "BF", optionLabel: 'BF - BURKINA FASO' },
    { optionValue: "BI", optionLabel: 'BI - BURUNDI' },
    { optionValue: "KH", optionLabel: 'KH - CAMBODIA' },
    { optionValue: "CM", optionLabel: 'CM - CAMEROON' },
    { optionValue: "CA", optionLabel: 'CA - CANADA' },
    { optionValue: "CV", optionLabel: 'CV - CAPE VERDE' },
    { optionValue: "KY", optionLabel: 'KY - CAYMAN ISLANDS' },
    { optionValue: "CF", optionLabel: 'CF - CENTRAL AFRICAN REPUBLIC' },
    { optionValue: "TD", optionLabel: 'TD - CHAD' },
    { optionValue: "CL", optionLabel: 'CL - CHILE' },
    { optionValue: "CN", optionLabel: 'CN - CHINA' },
    { optionValue: "CX", optionLabel: 'CX - CHRISTMAS ISLAND' },
    { optionValue: "CC", optionLabel: 'CC - COCOS (KEELING) ISLANDS' },
    { optionValue: "CO", optionLabel: 'CO - COLOMBIA' },
    { optionValue: "KM", optionLabel: 'KM - COMOROS' },
    { optionValue: "CG", optionLabel: 'CG - CONGO' },
    { optionValue: "CD", optionLabel: 'CD - CONGO, THE DEMOCRATIC REPUBLIC OF THE' },
    { optionValue: "CK", optionLabel: 'CK - COOK ISLANDS' },
    { optionValue: "CR", optionLabel: 'CR - COSTA RICA' },
    { optionValue: "CI", optionLabel: "CI - COTE D'IVOIRE" },
    { optionValue: "HR", optionLabel: 'HR - CROATIA' },
    { optionValue: "CU", optionLabel: 'CU - CUBA' },
    { optionValue: "CY", optionLabel: 'CY - CYPRUS' },
    { optionValue: "CZ", optionLabel: 'CZ - CZECH REPUBLIC' },
    { optionValue: "DK", optionLabel: 'DK - DENMARK' },
    { optionValue: "DJ", optionLabel: 'DJ - DJIBOUTI' },
    { optionValue: "DM", optionLabel: 'DM - DOMINICA' },
    { optionValue: "DO", optionLabel: 'DO - DOMINICAN REPUBLIC' },
    { optionValue: "EC", optionLabel: 'EC - ECUADOR' },
    { optionValue: "EG", optionLabel: 'EG - EGYPT' },
    { optionValue: "SV", optionLabel: 'SV - EL SALVADOR' },
    { optionValue: "GQ", optionLabel: 'GQ - EQUATORIAL GUINEA' },
    { optionValue: "ER", optionLabel: 'ER - ERITREA' },
    { optionValue: "EE", optionLabel: 'EE - ESTONIA' },
    { optionValue: "ET", optionLabel: 'ET - ETHIOPIA' },
    { optionValue: "FK", optionLabel: 'FK - FALKLAND ISLANDS (MALVINAS)' },
    { optionValue: "FO", optionLabel: 'FO - FAROE ISLANDS' },
    { optionValue: "FJ", optionLabel: 'FJ - FIJI' },
    { optionValue: "FI", optionLabel: 'FI - FINLAND' },
    { optionValue: "FR", optionLabel: 'FR - FRANCE' },
    { optionValue: "GF", optionLabel: 'GF - FRENCH GUIANA' },
    { optionValue: "PF", optionLabel: 'PF - FRENCH POLYNESIA' },
    { optionValue: "TF", optionLabel: 'TF - FRENCH SOUTHERN TERRITORIES' },
    { optionValue: "GA", optionLabel: 'GA - GABON' },
    { optionValue: "GM", optionLabel: 'GM - GAMBIA' },
    { optionValue: "GE", optionLabel: 'GE - GEORGIA' },
    { optionValue: "DE", optionLabel: 'DE - GERMANY' },
    { optionValue: "GH", optionLabel: 'GH - GHANA' },
    { optionValue: "GI", optionLabel: 'GI - GIBRALTAR' },
    { optionValue: "GR", optionLabel: 'GR - GREECE' },
    { optionValue: "GL", optionLabel: 'GL - GREENLAND' },
    { optionValue: "GD", optionLabel: 'GD - GRENADA' },
    { optionValue: "GP", optionLabel: 'GP - GUADELOUPE' },
    { optionValue: "GU", optionLabel: 'GU - GUAM' },
    { optionValue: "GT", optionLabel: 'GT - GUATEMALA' },
    { optionValue: "GG", optionLabel: 'GG - GUERNSEY' },
    { optionValue: "GN", optionLabel: 'GN - GUINEA' },
    { optionValue: "GW", optionLabel: 'GW - GUINEA-BISSAU' },
    { optionValue: "GY", optionLabel: 'GY - GUYANA' },
    { optionValue: "HT", optionLabel: 'HT - HAITI' },
    { optionValue: "HM", optionLabel: 'HM - HEARD ISLAND AND MCDONALD ISLANDS' },
    { optionValue: "VA", optionLabel: 'VA - HOLY SEE (VATICAN CITY STATE)' },
    { optionValue: "HN", optionLabel: 'HN - HONDURAS' },
    { optionValue: "HK", optionLabel: 'HK - HONG KONG' },
    { optionValue: "HU", optionLabel: 'HU - HUNGARY' },
    { optionValue: "IS", optionLabel: 'IS - ICELAND' },
    { optionValue: "IN", optionLabel: 'IN - INDIA' },
    { optionValue: "ID", optionLabel: 'ID - INDONESIA' },
    { optionValue: "IR", optionLabel: 'IR - IRAN, ISLAMIC REPUBLIC OF' },
    { optionValue: "IQ", optionLabel: 'IQ - IRAQ' },
    { optionValue: "IE", optionLabel: 'IE - IRELAND' },
    { optionValue: "IL", optionLabel: 'IL - ISRAEL' },
    { optionValue: "IT", optionLabel: 'IT - ITALY' },
    { optionValue: "JM", optionLabel: 'JM - JAMAICA' },
    { optionValue: "JP", optionLabel: 'JP - JAPAN' },
    { optionValue: "JE", optionLabel: 'JE - JERSEY' },
    { optionValue: "JO", optionLabel: 'JO - JORDAN' },
    { optionValue: "KZ", optionLabel: 'KZ - KAZAKHSTAN' },
    { optionValue: "KE", optionLabel: 'KE - KENYA' },
    { optionValue: "KI", optionLabel: 'KI - KIRIBATI' },
    { optionValue: "KP", optionLabel: "KP - KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
    { optionValue: "KR", optionLabel: 'KR - KOREA, REPUBLIC OF' },
    { optionValue: "KW", optionLabel: 'KW - KUWAIT' },
    { optionValue: "KG", optionLabel: 'KG - KYRGYZSTAN' },
    { optionValue: "LA", optionLabel: "LA - LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
    { optionValue: "LV", optionLabel: 'LV - LATVIA' },
    { optionValue: "LB", optionLabel: 'LB - LEBANON' },
    { optionValue: "LS", optionLabel: 'LS - LESOTHO' },
    { optionValue: "LR", optionLabel: 'LR - LIBERIA' },
    { optionValue: "LY", optionLabel: 'LY - LIBYAN ARAB JAMAHIRIYA' },
    { optionValue: "LI", optionLabel: 'LI - LIECHTENSTEIN' },
    { optionValue: "LT", optionLabel: 'LT - LITHUANIA' },
    { optionValue: "LU", optionLabel: 'LU - LUXEMBOURG' },
    { optionValue: "MO", optionLabel: 'MO - MACAO' },
    { optionValue: "MK", optionLabel: 'MK - MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF' },
    { optionValue: "MG", optionLabel: 'MG - MADAGASCAR' },
    { optionValue: "MW", optionLabel: 'MW - MALAWI' },
    { optionValue: "MY", optionLabel: 'MY - MALAYSIA' },
    { optionValue: "MV", optionLabel: 'MV - MALDIVES' },
    { optionValue: "ML", optionLabel: 'ML - MALI' },
    { optionValue: "MT", optionLabel: 'MT - MALTA' },
    { optionValue: "MH", optionLabel: 'MH - MARSHALL ISLANDS' },
    { optionValue: "MQ", optionLabel: 'MQ - MARTINIQUE' },
    { optionValue: "MR", optionLabel: 'MR - MAURITANIA' },
    { optionValue: "MU", optionLabel: 'MU - MAURITIUS' },
    { optionValue: "YT", optionLabel: 'YT - MAYOTTE' },
    { optionValue: "MX", optionLabel: 'MX - MEXICO' },
    { optionValue: "FM", optionLabel: 'FM - MICRONESIA, FEDERATED STATES OF' },
    { optionValue: "MD", optionLabel: 'MD - MOLDOVA, REPUBLIC OF' },
    { optionValue: "MN", optionLabel: 'MN - MONGOLIA' },
    { optionValue: "ME", optionLabel: 'ME - MONTENEGRO' },
    { optionValue: "MS", optionLabel: 'MS - MONTSERRAT' },
    { optionValue: "MA", optionLabel: 'MA - MOROCCO' },
    { optionValue: "MZ", optionLabel: 'MZ - MOZAMBIQUE' },
    { optionValue: "MM", optionLabel: 'MM - MYANMAR' },
    { optionValue: "NA", optionLabel: 'NA - NAMIBIA' },
    { optionValue: "NR", optionLabel: 'NR - NAURU' },
    { optionValue: "NP", optionLabel: 'NP - NEPAL' },
    { optionValue: "NL", optionLabel: 'NL - NETHERLANDS' },
    { optionValue: "NC", optionLabel: 'NC - NEW CALEDONIA' },
    { optionValue: "NZ", optionLabel: 'NZ - NEW ZEALAND' },
    { optionValue: "NI", optionLabel: 'NI - NICARAGUA' },
    { optionValue: "NE", optionLabel: 'NE - NIGER' },
    { optionValue: "NG", optionLabel: 'NG - NIGERIA' },
    { optionValue: "NU", optionLabel: 'NU - NIUE' },
    { optionValue: "NF", optionLabel: 'NF - NORFOLK ISLAND' },
    { optionValue: "MP", optionLabel: 'MP - NORTHERN MARIANA ISLANDS' },
    { optionValue: "NO", optionLabel: 'NO - NORWAY' },
    { optionValue: "OM", optionLabel: 'OM - OMAN' },
    { optionValue: "PK", optionLabel: 'PK - PAKISTAN' },
    { optionValue: "PW", optionLabel: 'PW - PALAU' },
    { optionValue: "PS", optionLabel: 'PS - PALESTINIAN TERRITORY, OCCUPIED' },
    { optionValue: "PA", optionLabel: 'PA - PANAMA' },
    { optionValue: "PG", optionLabel: 'PG - PAPUA NEW GUINEA' },
    { optionValue: "PY", optionLabel: 'PY - PARAGUAY' },
    { optionValue: "PE", optionLabel: 'PE - PERU' },
    { optionValue: "PH", optionLabel: 'PH - PHILIPPINES' },
    { optionValue: "PN", optionLabel: 'PN - PITCAIRN' },
    { optionValue: "PL", optionLabel: 'PL - POLAND' },
    { optionValue: "PT", optionLabel: 'PT - PORTUGAL' },
    { optionValue: "PR", optionLabel: 'PR - PUERTO RICO' },
    { optionValue: "QA", optionLabel: 'QA - QATAR' },
    { optionValue: "RE", optionLabel: 'RE - REUNION' },
    { optionValue: "RO", optionLabel: 'RO - ROMANIA' },
    { optionValue: "RU", optionLabel: 'RU - RUSSIAN FEDERATION' },
    { optionValue: "RW", optionLabel: 'RW - RWANDA' },
    { optionValue: "BL", optionLabel: 'BL - SAINT BARTHÉLEMY' },
    { optionValue: "SH", optionLabel: 'SH - SAINT HELENA' },
    { optionValue: "KN", optionLabel: 'KN - SAINT KITTS AND NEVIS' },
    { optionValue: "LC", optionLabel: 'LC - SAINT LUCIA' },
    { optionValue: "MF", optionLabel: 'MF - SAINT MARTIN' },
    { optionValue: "PM", optionLabel: 'PM - SAINT PIERRE AND MIQUELON' },
    { optionValue: "VC", optionLabel: 'VC - SAINT VINCENT AND THE GRENADINES' },
    { optionValue: "WS", optionLabel: 'WS - SAMOA' },
    { optionValue: "SM", optionLabel: 'SM - SAN MARINO' },
    { optionValue: "ST", optionLabel: 'ST - SAO TOME AND PRINCIPE' },
    { optionValue: "SA", optionLabel: 'SA - SAUDI ARABIA' },
    { optionValue: "SN", optionLabel: 'SN - SENEGAL' },
    { optionValue: "RS", optionLabel: 'RS - SERBIA' },
    { optionValue: "SC", optionLabel: 'SC - SEYCHELLES' },
    { optionValue: "SL", optionLabel: 'SL - SIERRA LEONE' },
    { optionValue: "SG", optionLabel: 'SG - SINGAPORE' },
    { optionValue: "SK", optionLabel: 'SK - SLOVAKIA' },
    { optionValue: "SI", optionLabel: 'SI - SLOVENIA' },
    { optionValue: "SB", optionLabel: 'SB - SOLOMON ISLANDS' },
    { optionValue: "SO", optionLabel: 'SO - SOMALIA' },
    { optionValue: "ZA", optionLabel: 'ZA - SOUTH AFRICA' },
    { optionValue: "GS", optionLabel: 'GS - SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS' },
    { optionValue: "SS", optionLabel: 'SS - SOUTH SUDAN' },
    { optionValue: "ES", optionLabel: 'ES - SPAIN' },
    { optionValue: "LK", optionLabel: 'LK - SRI LANKA' },
    { optionValue: "SD", optionLabel: 'SD - SUDAN' },
    { optionValue: "SR", optionLabel: 'SR - SURINAME' },
    { optionValue: "SJ", optionLabel: 'SJ - SVALBARD AND JAN MAYEN' },
    { optionValue: "SZ", optionLabel: 'SZ - SWAZILAND' },
    { optionValue: "SE", optionLabel: 'SE - SWEDEN' },
    { optionValue: "CH", optionLabel: 'CH - SWITZERLAND' },
    { optionValue: "SY", optionLabel: 'SY - SYRIAN ARAB REPUBLIC' },
    { optionValue: "TW", optionLabel: 'TW - TAIWAN, PROVINCE OF CHINA' },
    { optionValue: "TJ", optionLabel: 'TJ - TAJIKISTAN' },
    { optionValue: "TZ", optionLabel: 'TZ - TANZANIA, UNITED REPUBLIC OF' },
    { optionValue: "TH", optionLabel: 'TH - THAILAND' },
    { optionValue: "TL", optionLabel: 'TL - TIMOR-LESTE' },
    { optionValue: "TG", optionLabel: 'TG - TOGO' },
    { optionValue: "TK", optionLabel: 'TK - TOKELAU' },
    { optionValue: "TO", optionLabel: 'TO - TONGA' },
    { optionValue: "TT", optionLabel: 'TT - TRINIDAD AND TOBAGO' },
    { optionValue: "TN", optionLabel: 'TN - TUNISIA' },
    { optionValue: "TR", optionLabel: 'TR - TURKEY' },
    { optionValue: "TM", optionLabel: 'TM - TURKMENISTAN' },
    { optionValue: "TC", optionLabel: 'TC - TURKS AND CAICOS ISLANDS' },
    { optionValue: "TV", optionLabel: 'TV - TUVALU' },
    { optionValue: "UG", optionLabel: 'UG - UGANDA' },
    { optionValue: "UA", optionLabel: 'UA - UKRAINE' },
    { optionValue: "AE", optionLabel: 'AE - UNITED ARAB EMIRATES' },
    { optionValue: "GB", optionLabel: 'GB - UNITED KINGDOM' },
    { optionValue: "US", optionLabel: 'US - UNITED STATES' },
    { optionValue: "UM", optionLabel: 'UM - UNITED STATES MINOR OUTLYING ISLANDS' },
    { optionValue: "UY", optionLabel: 'UY - URUGUAY' },
    { optionValue: "UZ", optionLabel: 'UZ - UZBEKISTAN' },
    { optionValue: "VU", optionLabel: 'VU - VANUATU' },
    { optionValue: "VE", optionLabel: 'VE - VENEZUELA, BOLIVARIAN REPUBLIC OF' },
    { optionValue: "VN", optionLabel: 'VN - VIET NAM' },
    { optionValue: "VG", optionLabel: 'VG - VIRGIN ISLANDS, BRITISH' },
    { optionValue: "VI", optionLabel: 'VI - VIRGIN ISLANDS, U.S.' },
    { optionValue: "WF", optionLabel: 'WF - WALLIS AND FUTUNA' },
    { optionValue: "EH", optionLabel: 'EH - WESTERN SAHARA' },
    { optionValue: "YE", optionLabel: 'YE - YEMEN' },
    { optionValue: "ZM", optionLabel: 'ZM - ZAMBIA' },
    { optionValue: "ZW", optionLabel: 'ZW - ZIMBABWE' }
]

export const genderOptions =[
    { optionValue: "", optionLabel: '' },
    { optionValue: "M", optionLabel: 'Male' },
    { optionValue: "F", optionLabel: 'Female' }
]

export const titleOptions =[
    { optionValue: "", optionLabel: '' },
    { optionValue: "MR", optionLabel: 'Mr.' },
    { optionValue: "MRS", optionLabel: 'Ms.' }
]

export const listaStatiNascita = [
    { optionValue: "", optionLabel: '' },
    { optionValue: "AF", optionLabel: 'AF - AFGHANISTAN' },
    { optionValue: "AX", optionLabel: 'AX - ÅLAND ISLANDS' },
    { optionValue: "AL", optionLabel: 'AL - ALBANIA' },
    { optionValue: "DZ", optionLabel: 'DZ - ALGERIA' },
    { optionValue: "AS", optionLabel: 'AS - AMERICAN SAMOA' },
    { optionValue: "AD", optionLabel: 'AD - ANDORRA' },
    { optionValue: "AO", optionLabel: 'AO - ANGOLA' },
    { optionValue: "AI", optionLabel: 'AI - ANGUILLA' },
    { optionValue: "AQ", optionLabel: 'AQ - ANTARCTICA' },
    { optionValue: "AG", optionLabel: 'AG - ANTIGUA AND BARBUDA' },
    { optionValue: "AR", optionLabel: 'AR - ARGENTINA' },
    { optionValue: "AM", optionLabel: 'AM - ARMENIA' },
    { optionValue: "AW", optionLabel: 'AW - ARUBA' },
    { optionValue: "AU", optionLabel: 'AU - AUSTRALIA' },
    { optionValue: "AT", optionLabel: 'AT - AUSTRIA' },
    { optionValue: "AZ", optionLabel: 'AZ - AZERBAIJAN' },
    { optionValue: "BS", optionLabel: 'BS - BAHAMAS' },
    { optionValue: "BH", optionLabel: 'BH - BAHRAIN' },
    { optionValue: "BD", optionLabel: 'BD - BANGLADESH' },
    { optionValue: "BB", optionLabel: 'BB - BARBADOS' },
    { optionValue: "BY", optionLabel: 'BY - BELARUS' },
    { optionValue: "BE", optionLabel: 'BE - BELGIUM' },
    { optionValue: "BZ", optionLabel: 'BZ - BELIZE' },
    { optionValue: "BJ", optionLabel: 'BJ - BENIN' },
    { optionValue: "BM", optionLabel: 'BM - BERMUDA' },
    { optionValue: "BT", optionLabel: 'BT - BHUTAN' },
    { optionValue: "BO", optionLabel: 'BO - BOLIVIA' },
    { optionValue: "BA", optionLabel: 'BA - BOSNIA AND HERZEGOVINA' },
    { optionValue: "BW", optionLabel: 'BW - BOTSWANA' },
    { optionValue: "BV", optionLabel: 'BV - BOUVET ISLAND' },
    { optionValue: "BR", optionLabel: 'BR - BRAZIL' },
    { optionValue: "IO", optionLabel: 'IO - BRITISH INDIAN OCEAN TERRITORY' },
    { optionValue: "BN", optionLabel: 'BN - BRUNEI DARUSSALAM' },
    { optionValue: "BG", optionLabel: 'BG - BULGARIA' },
    { optionValue: "BF", optionLabel: 'BF - BURKINA FASO' },
    { optionValue: "BI", optionLabel: 'BI - BURUNDI' },
    { optionValue: "KH", optionLabel: 'KH - CAMBODIA' },
    { optionValue: "CM", optionLabel: 'CM - CAMEROON' },
    { optionValue: "CA", optionLabel: 'CA - CANADA' },
    { optionValue: "CV", optionLabel: 'CV - CAPE VERDE' },
    { optionValue: "KY", optionLabel: 'KY - CAYMAN ISLANDS' },
    { optionValue: "CF", optionLabel: 'CF - CENTRAL AFRICAN REPUBLIC' },
    { optionValue: "TD", optionLabel: 'TD - CHAD' },
    { optionValue: "CL", optionLabel: 'CL - CHILE' },
    { optionValue: "CN", optionLabel: 'CN - CHINA' },
    { optionValue: "CX", optionLabel: 'CX - CHRISTMAS ISLAND' },
    { optionValue: "CC", optionLabel: 'CC - COCOS (KEELING) ISLANDS' },
    { optionValue: "CO", optionLabel: 'CO - COLOMBIA' },
    { optionValue: "KM", optionLabel: 'KM - COMOROS' },
    { optionValue: "CG", optionLabel: 'CG - CONGO' },
    { optionValue: "CD", optionLabel: 'CD - CONGO, THE DEMOCRATIC REPUBLIC OF THE' },
    { optionValue: "CK", optionLabel: 'CK - COOK ISLANDS' },
    { optionValue: "CR", optionLabel: 'CR - COSTA RICA' },
    { optionValue: "CI", optionLabel: "CI - COTE D'IVOIRE" },
    { optionValue: "HR", optionLabel: 'HR - CROATIA' },
    { optionValue: "CU", optionLabel: 'CU - CUBA' },
    { optionValue: "CY", optionLabel: 'CY - CYPRUS' },
    { optionValue: "CZ", optionLabel: 'CZ - CZECH REPUBLIC' },
    { optionValue: "DK", optionLabel: 'DK - DENMARK' },
    { optionValue: "DJ", optionLabel: 'DJ - DJIBOUTI' },
    { optionValue: "DM", optionLabel: 'DM - DOMINICA' },
    { optionValue: "DO", optionLabel: 'DO - DOMINICAN REPUBLIC' },
    { optionValue: "EC", optionLabel: 'EC - ECUADOR' },
    { optionValue: "EG", optionLabel: 'EG - EGYPT' },
    { optionValue: "SV", optionLabel: 'SV - EL SALVADOR' },
    { optionValue: "GQ", optionLabel: 'GQ - EQUATORIAL GUINEA' },
    { optionValue: "ER", optionLabel: 'ER - ERITREA' },
    { optionValue: "EE", optionLabel: 'EE - ESTONIA' },
    { optionValue: "ET", optionLabel: 'ET - ETHIOPIA' },
    { optionValue: "FK", optionLabel: 'FK - FALKLAND ISLANDS (MALVINAS)' },
    { optionValue: "FO", optionLabel: 'FO - FAROE ISLANDS' },
    { optionValue: "FJ", optionLabel: 'FJ - FIJI' },
    { optionValue: "FI", optionLabel: 'FI - FINLAND' },
    { optionValue: "FR", optionLabel: 'FR - FRANCE' },
    { optionValue: "GF", optionLabel: 'GF - FRENCH GUIANA' },
    { optionValue: "PF", optionLabel: 'PF - FRENCH POLYNESIA' },
    { optionValue: "TF", optionLabel: 'TF - FRENCH SOUTHERN TERRITORIES' },
    { optionValue: "GA", optionLabel: 'GA - GABON' },
    { optionValue: "GM", optionLabel: 'GM - GAMBIA' },
    { optionValue: "GE", optionLabel: 'GE - GEORGIA' },
    { optionValue: "DE", optionLabel: 'DE - GERMANY' },
    { optionValue: "GH", optionLabel: 'GH - GHANA' },
    { optionValue: "GI", optionLabel: 'GI - GIBRALTAR' },
    { optionValue: "GR", optionLabel: 'GR - GREECE' },
    { optionValue: "GL", optionLabel: 'GL - GREENLAND' },
    { optionValue: "GD", optionLabel: 'GD - GRENADA' },
    { optionValue: "GP", optionLabel: 'GP - GUADELOUPE' },
    { optionValue: "GU", optionLabel: 'GU - GUAM' },
    { optionValue: "GT", optionLabel: 'GT - GUATEMALA' },
    { optionValue: "GG", optionLabel: 'GG - GUERNSEY' },
    { optionValue: "GN", optionLabel: 'GN - GUINEA' },
    { optionValue: "GW", optionLabel: 'GW - GUINEA-BISSAU' },
    { optionValue: "GY", optionLabel: 'GY - GUYANA' },
    { optionValue: "HT", optionLabel: 'HT - HAITI' },
    { optionValue: "HM", optionLabel: 'HM - HEARD ISLAND AND MCDONALD ISLANDS' },
    { optionValue: "VA", optionLabel: 'VA - HOLY SEE (VATICAN CITY STATE)' },
    { optionValue: "HN", optionLabel: 'HN - HONDURAS' },
    { optionValue: "HK", optionLabel: 'HK - HONG KONG' },
    { optionValue: "HU", optionLabel: 'HU - HUNGARY' },
    { optionValue: "IS", optionLabel: 'IS - ICELAND' },
    { optionValue: "IN", optionLabel: 'IN - INDIA' },
    { optionValue: "ID", optionLabel: 'ID - INDONESIA' },
    { optionValue: "IR", optionLabel: 'IR - IRAN, ISLAMIC REPUBLIC OF' },
    { optionValue: "IQ", optionLabel: 'IQ - IRAQ' },
    { optionValue: "IE", optionLabel: 'IE - IRELAND' },
    { optionValue: "IL", optionLabel: 'IL - ISRAEL' },
    { optionValue: "IT", optionLabel: 'IT - ITALY' },
    { optionValue: "JM", optionLabel: 'JM - JAMAICA' },
    { optionValue: "JP", optionLabel: 'JP - JAPAN' },
    { optionValue: "JE", optionLabel: 'JE - JERSEY' },
    { optionValue: "JO", optionLabel: 'JO - JORDAN' },
    { optionValue: "KZ", optionLabel: 'KZ - KAZAKHSTAN' },
    { optionValue: "KE", optionLabel: 'KE - KENYA' },
    { optionValue: "KI", optionLabel: 'KI - KIRIBATI' },
    { optionValue: "KP", optionLabel: "KP - KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
    { optionValue: "KR", optionLabel: 'KR - KOREA, REPUBLIC OF' },
    { optionValue: "KW", optionLabel: 'KW - KUWAIT' },
    { optionValue: "KG", optionLabel: 'KG - KYRGYZSTAN' },
    { optionValue: "LA", optionLabel: "LA - LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
    { optionValue: "LV", optionLabel: 'LV - LATVIA' },
    { optionValue: "LB", optionLabel: 'LB - LEBANON' },
    { optionValue: "LS", optionLabel: 'LS - LESOTHO' },
    { optionValue: "LR", optionLabel: 'LR - LIBERIA' },
    { optionValue: "LY", optionLabel: 'LY - LIBYAN ARAB JAMAHIRIYA' },
    { optionValue: "LI", optionLabel: 'LI - LIECHTENSTEIN' },
    { optionValue: "LT", optionLabel: 'LT - LITHUANIA' },
    { optionValue: "LU", optionLabel: 'LU - LUXEMBOURG' },
    { optionValue: "MO", optionLabel: 'MO - MACAO' },
    { optionValue: "MK", optionLabel: 'MK - MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF' },
    { optionValue: "MG", optionLabel: 'MG - MADAGASCAR' },
    { optionValue: "MW", optionLabel: 'MW - MALAWI' },
    { optionValue: "MY", optionLabel: 'MY - MALAYSIA' },
    { optionValue: "MV", optionLabel: 'MV - MALDIVES' },
    { optionValue: "ML", optionLabel: 'ML - MALI' },
    { optionValue: "MT", optionLabel: 'MT - MALTA' },
    { optionValue: "MH", optionLabel: 'MH - MARSHALL ISLANDS' },
    { optionValue: "MQ", optionLabel: 'MQ - MARTINIQUE' },
    { optionValue: "MR", optionLabel: 'MR - MAURITANIA' },
    { optionValue: "MU", optionLabel: 'MU - MAURITIUS' },
    { optionValue: "YT", optionLabel: 'YT - MAYOTTE' },
    { optionValue: "MX", optionLabel: 'MX - MEXICO' },
    { optionValue: "FM", optionLabel: 'FM - MICRONESIA, FEDERATED STATES OF' },
    { optionValue: "MD", optionLabel: 'MD - MOLDOVA, REPUBLIC OF' },
    { optionValue: "MN", optionLabel: 'MN - MONGOLIA' },
    { optionValue: "ME", optionLabel: 'ME - MONTENEGRO' },
    { optionValue: "MS", optionLabel: 'MS - MONTSERRAT' },
    { optionValue: "MA", optionLabel: 'MA - MOROCCO' },
    { optionValue: "MZ", optionLabel: 'MZ - MOZAMBIQUE' },
    { optionValue: "MM", optionLabel: 'MM - MYANMAR' },
    { optionValue: "NA", optionLabel: 'NA - NAMIBIA' },
    { optionValue: "NR", optionLabel: 'NR - NAURU' },
    { optionValue: "NP", optionLabel: 'NP - NEPAL' },
    { optionValue: "NL", optionLabel: 'NL - NETHERLANDS' },
    { optionValue: "NC", optionLabel: 'NC - NEW CALEDONIA' },
    { optionValue: "NZ", optionLabel: 'NZ - NEW ZEALAND' },
    { optionValue: "NI", optionLabel: 'NI - NICARAGUA' },
    { optionValue: "NE", optionLabel: 'NE - NIGER' },
    { optionValue: "NG", optionLabel: 'NG - NIGERIA' },
    { optionValue: "NU", optionLabel: 'NU - NIUE' },
    { optionValue: "NF", optionLabel: 'NF - NORFOLK ISLAND' },
    { optionValue: "MP", optionLabel: 'MP - NORTHERN MARIANA ISLANDS' },
    { optionValue: "NO", optionLabel: 'NO - NORWAY' },
    { optionValue: "OM", optionLabel: 'OM - OMAN' },
    { optionValue: "PK", optionLabel: 'PK - PAKISTAN' },
    { optionValue: "PW", optionLabel: 'PW - PALAU' },
    { optionValue: "PS", optionLabel: 'PS - PALESTINIAN TERRITORY, OCCUPIED' },
    { optionValue: "PA", optionLabel: 'PA - PANAMA' },
    { optionValue: "PG", optionLabel: 'PG - PAPUA NEW GUINEA' },
    { optionValue: "PY", optionLabel: 'PY - PARAGUAY' },
    { optionValue: "PE", optionLabel: 'PE - PERU' },
    { optionValue: "PH", optionLabel: 'PH - PHILIPPINES' },
    { optionValue: "PN", optionLabel: 'PN - PITCAIRN' },
    { optionValue: "PL", optionLabel: 'PL - POLAND' },
    { optionValue: "PT", optionLabel: 'PT - PORTUGAL' },
    { optionValue: "PR", optionLabel: 'PR - PUERTO RICO' },
    { optionValue: "QA", optionLabel: 'QA - QATAR' },
    { optionValue: "RE", optionLabel: 'RE - REUNION' },
    { optionValue: "RO", optionLabel: 'RO - ROMANIA' },
    { optionValue: "RU", optionLabel: 'RU - RUSSIAN FEDERATION' },
    { optionValue: "RW", optionLabel: 'RW - RWANDA' },
    { optionValue: "BL", optionLabel: 'BL - SAINT BARTHÉLEMY' },
    { optionValue: "SH", optionLabel: 'SH - SAINT HELENA' },
    { optionValue: "KN", optionLabel: 'KN - SAINT KITTS AND NEVIS' },
    { optionValue: "LC", optionLabel: 'LC - SAINT LUCIA' },
    { optionValue: "MF", optionLabel: 'MF - SAINT MARTIN' },
    { optionValue: "PM", optionLabel: 'PM - SAINT PIERRE AND MIQUELON' },
    { optionValue: "VC", optionLabel: 'VC - SAINT VINCENT AND THE GRENADINES' },
    { optionValue: "WS", optionLabel: 'WS - SAMOA' },
    { optionValue: "SM", optionLabel: 'SM - SAN MARINO' },
    { optionValue: "ST", optionLabel: 'ST - SAO TOME AND PRINCIPE' },
    { optionValue: "SA", optionLabel: 'SA - SAUDI ARABIA' },
    { optionValue: "SN", optionLabel: 'SN - SENEGAL' },
    { optionValue: "RS", optionLabel: 'RS - SERBIA' },
    { optionValue: "SC", optionLabel: 'SC - SEYCHELLES' },
    { optionValue: "SL", optionLabel: 'SL - SIERRA LEONE' },
    { optionValue: "SG", optionLabel: 'SG - SINGAPORE' },
    { optionValue: "SK", optionLabel: 'SK - SLOVAKIA' },
    { optionValue: "SI", optionLabel: 'SI - SLOVENIA' },
    { optionValue: "SB", optionLabel: 'SB - SOLOMON ISLANDS' },
    { optionValue: "SO", optionLabel: 'SO - SOMALIA' },
    { optionValue: "ZA", optionLabel: 'ZA - SOUTH AFRICA' },
    { optionValue: "GS", optionLabel: 'GS - SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS' },
    { optionValue: "SS", optionLabel: 'SS - SOUTH SUDAN' },
    { optionValue: "ES", optionLabel: 'ES - SPAIN' },
    { optionValue: "LK", optionLabel: 'LK - SRI LANKA' },
    { optionValue: "SD", optionLabel: 'SD - SUDAN' },
    { optionValue: "SR", optionLabel: 'SR - SURINAME' },
    { optionValue: "SJ", optionLabel: 'SJ - SVALBARD AND JAN MAYEN' },
    { optionValue: "SZ", optionLabel: 'SZ - SWAZILAND' },
    { optionValue: "SE", optionLabel: 'SE - SWEDEN' },
    { optionValue: "CH", optionLabel: 'CH - SWITZERLAND' },
    { optionValue: "SY", optionLabel: 'SY - SYRIAN ARAB REPUBLIC' },
    { optionValue: "TW", optionLabel: 'TW - TAIWAN, PROVINCE OF CHINA' },
    { optionValue: "TJ", optionLabel: 'TJ - TAJIKISTAN' },
    { optionValue: "TZ", optionLabel: 'TZ - TANZANIA, UNITED REPUBLIC OF' },
    { optionValue: "TH", optionLabel: 'TH - THAILAND' },
    { optionValue: "TL", optionLabel: 'TL - TIMOR-LESTE' },
    { optionValue: "TG", optionLabel: 'TG - TOGO' },
    { optionValue: "TK", optionLabel: 'TK - TOKELAU' },
    { optionValue: "TO", optionLabel: 'TO - TONGA' },
    { optionValue: "TT", optionLabel: 'TT - TRINIDAD AND TOBAGO' },
    { optionValue: "TN", optionLabel: 'TN - TUNISIA' },
    { optionValue: "TR", optionLabel: 'TR - TURKEY' },
    { optionValue: "TM", optionLabel: 'TM - TURKMENISTAN' },
    { optionValue: "TC", optionLabel: 'TC - TURKS AND CAICOS ISLANDS' },
    { optionValue: "TV", optionLabel: 'TV - TUVALU' },
    { optionValue: "UG", optionLabel: 'UG - UGANDA' },
    { optionValue: "UA", optionLabel: 'UA - UKRAINE' },
    { optionValue: "AE", optionLabel: 'AE - UNITED ARAB EMIRATES' },
    { optionValue: "GB", optionLabel: 'GB - UNITED KINGDOM' },
    { optionValue: "US", optionLabel: 'US - UNITED STATES' },
    { optionValue: "UM", optionLabel: 'UM - UNITED STATES MINOR OUTLYING ISLANDS' },
    { optionValue: "UY", optionLabel: 'UY - URUGUAY' },
    { optionValue: "UZ", optionLabel: 'UZ - UZBEKISTAN' },
    { optionValue: "VU", optionLabel: 'VU - VANUATU' },
    { optionValue: "VE", optionLabel: 'VE - VENEZUELA, BOLIVARIAN REPUBLIC OF' },
    { optionValue: "VN", optionLabel: 'VN - VIET NAM' },
    { optionValue: "VG", optionLabel: 'VG - VIRGIN ISLANDS, BRITISH' },
    { optionValue: "VI", optionLabel: 'VI - VIRGIN ISLANDS, U.S.' },
    { optionValue: "WF", optionLabel: 'WF - WALLIS AND FUTUNA' },
    { optionValue: "EH", optionLabel: 'EH - WESTERN SAHARA' },
    { optionValue: "YE", optionLabel: 'YE - YEMEN' },
    { optionValue: "ZM", optionLabel: 'ZM - ZAMBIA' },
    { optionValue: "ZW", optionLabel: 'ZW - ZIMBABWE' }
]

export const listaStatiExtraUE = [
    { optionValue: "", optionLabel: '' },
    { optionValue: "AF", optionLabel:'AF - AFGHANISTAN'},
    { optionValue: "AX", optionLabel:'AX - ÅLAND ISLANDS'},
    { optionValue: "AL", optionLabel:'AL - ALBANIA'},
    { optionValue: "XG", optionLabel:'XG - ALDERNEY'},
    { optionValue: "DZ", optionLabel:'DZ - ALGERIA'},
    { optionValue: "AS", optionLabel:'AS - AMERICAN SAMOA'},
    { optionValue: "AD", optionLabel:'AD - ANDORRA'},
    { optionValue: "AO", optionLabel:'AO - ANGOLA'},
    { optionValue: "AI", optionLabel:'AI - ANGUILLA'},
    { optionValue: "AQ", optionLabel:'AQ - ANTARCTICA'},
    { optionValue: "AG", optionLabel:'AG - ANTIGUA AND BARBUDA'},
    { optionValue: "AR", optionLabel:'AR - ARGENTINA'},
    { optionValue: "AM", optionLabel:'AM - ARMENIA'},
    { optionValue: "AW", optionLabel:'AW - ARUBA'},
    { optionValue: "AU", optionLabel:'AU - AUSTRALIA'},
    { optionValue: "AZ", optionLabel:'AZ - AZERBAIJAN'},
    { optionValue: "BS", optionLabel:'BS - BAHAMAS'},
    { optionValue: "BH", optionLabel:'BH - BAHRAIN'},
    { optionValue: "BD", optionLabel:'BD - BANGLADESH'},
    { optionValue: "BB", optionLabel:'BB - BARBADOS'},
    { optionValue: "BY", optionLabel:'BY - BELARUS'},
    { optionValue: "BZ", optionLabel:'BZ - BELIZE'},
    { optionValue: "BJ", optionLabel:'BJ - BENIN'},
    { optionValue: "BM", optionLabel:'BM - BERMUDA'},
    { optionValue: "BT", optionLabel:'BT - BHUTAN'},
    { optionValue: "BO", optionLabel:'BO - BOLIVIA'},
    { optionValue: "BQ", optionLabel:'BQ - BONAIRE, SAINT EUSTATIUS AND SABA'},
    { optionValue: "BA", optionLabel:'BA - BOSNIA AND HERZEGOVINA'},
    { optionValue: "BW", optionLabel:'BW - BOTSWANA'},
    { optionValue: "BV", optionLabel:'BV - BOUVET ISLAND'},
    { optionValue: "BR", optionLabel:'BR - BRAZIL'},
    { optionValue: "IO", optionLabel:'IO - BRITISH INDIAN OCEAN TERRITORY'},
    { optionValue: "BN", optionLabel:'BN - BRUNEI DARUSSALAM'},
    { optionValue: "XB", optionLabel:'XB - BUESINGEN'},
    { optionValue: "BF", optionLabel:'BF - BURKINA FASO'},
    { optionValue: "BI", optionLabel:'BI - BURUNDI'},
    { optionValue: "KH", optionLabel:'KH - CAMBODIA'},
    { optionValue: "CM", optionLabel:'CM - CAMEROON'},
    { optionValue: "XD", optionLabel:"XD - CAMPIONE D'ITALIA"},
    { optionValue: "CA", optionLabel:'CA - CANADA'},
    { optionValue: "IC", optionLabel:'IC - CANARY ISLANDS'},
    { optionValue: "CV", optionLabel:'CV - CAPE VERDE'},
    { optionValue: "KY", optionLabel:'KY - CAYMAN ISLANDS'},
    { optionValue: "CF", optionLabel:'CF - CENTRAL AFRICAN REPUBLIC'},
    { optionValue: "XC", optionLabel:'XC - CEUTA'},
    { optionValue: "TD", optionLabel:'TD - CHAD'},
    { optionValue: "CL", optionLabel:'CL - CHILE'},
    { optionValue: "CN", optionLabel:'CN - CHINA'},
    { optionValue: "CX", optionLabel:'CX - CHRISTMAS ISLAND'},
    { optionValue: "CC", optionLabel:'CC - COCOS (KEELING) ISLANDS'},
    { optionValue: "CO", optionLabel:'CO - COLOMBIA'},
    { optionValue: "KM", optionLabel:'KM - COMOROS'},
    { optionValue: "CG", optionLabel:'CG - CONGO'},
    { optionValue: "CD", optionLabel:'CD - CONGO, THE DEMOCRATIC REPUBLIC OF THE'},
    { optionValue: "CK", optionLabel:'CK - COOK ISLANDS'},
    { optionValue: "CR", optionLabel:'CR - COSTA RICA'},
    { optionValue: "CI", optionLabel:"CI - COTE D'IVOIRE"},
    { optionValue: "CU", optionLabel:'CU - CUBA'},
    { optionValue: "CW", optionLabel:'CW - CURACAO'},
    { optionValue: "DJ", optionLabel:'DJ - DJIBOUTI'},
    { optionValue: "DM", optionLabel:'DM - DOMINICA'},
    { optionValue: "DO", optionLabel:'DO - DOMINICAN REPUBLIC'},
    { optionValue: "EC", optionLabel:'EC - ECUADOR'},
    { optionValue: "EG", optionLabel:'EG - EGYPT'},
    { optionValue: "SV", optionLabel:'SV - EL SALVADOR'},
    { optionValue: "GQ", optionLabel:'GQ - EQUATORIAL GUINEA'},
    { optionValue: "ER", optionLabel:'ER - ERITREA'},
    { optionValue: "ET", optionLabel:'ET - ETHIOPIA'},
    { optionValue: "FK", optionLabel:'FK - FALKLAND ISLANDS (MALVINAS)'},
    { optionValue: "FO", optionLabel:'FO - FAROE ISLANDS'},
    { optionValue: "FJ", optionLabel:'FJ - FIJI'},
    { optionValue: "GF", optionLabel:'GF - FRENCH GUIANA'},
    { optionValue: "PF", optionLabel:'PF - FRENCH POLYNESIA'},
    { optionValue: "TF", optionLabel:'TF - FRENCH SOUTHERN TERRITORIES'},
    { optionValue: "GA", optionLabel:'GA - GABON'},
    { optionValue: "GM", optionLabel:'GM - GAMBIA'},
    { optionValue: "GE", optionLabel:'GE - GEORGIA'},
    { optionValue: "GH", optionLabel:'GH - GHANA'},
    { optionValue: "GI", optionLabel:'GI - GIBRALTAR'},
    { optionValue: "GL", optionLabel:'GL - GREENLAND'},
    { optionValue: "GD", optionLabel:'GD - GRENADA'},
    { optionValue: "GP", optionLabel:'GP - GUADELOUPE'},
    { optionValue: "GU", optionLabel:'GU - GUAM'},
    { optionValue: "GT", optionLabel:'GT - GUATEMALA'},
    { optionValue: "GG", optionLabel:'GG - GUERNSEY'},
    { optionValue: "GN", optionLabel:'GN - GUINEA'},
    { optionValue: "GW", optionLabel:'GW - GUINEA-BISSAU'},
    { optionValue: "GY", optionLabel:'GY - GUYANA'},
    { optionValue: "HT", optionLabel:'HT - HAITI'},
    { optionValue: "HM", optionLabel:'HM - HEARD ISLAND AND MCDONALD ISLANDS'},
    { optionValue: "XA", optionLabel:'XA - HELIOGOLAND'},
    { optionValue: "VA", optionLabel:'VA - HOLY SEE (VATICAN CITY STATE)'},
    { optionValue: "HN", optionLabel:'HN - HONDURAS'},
    { optionValue: "HK", optionLabel:'HK - HONG KONG'},
    { optionValue: "IS", optionLabel:'IS - ICELAND'},
    { optionValue: "IN", optionLabel:'IN - INDIA'},
    { optionValue: "ID", optionLabel:'ID - INDONESIA'},
    { optionValue: "IR", optionLabel:'IR - IRAN, ISLAMIC REPUBLIC OF'},
    { optionValue: "IQ", optionLabel:'IQ - IRAQ'},
    { optionValue: "IM", optionLabel:'IM - ISLE OF MAN'},
    { optionValue: "IL", optionLabel:'IL - ISRAEL'},
    { optionValue: "JM", optionLabel:'JM - JAMAICA'},
    { optionValue: "JP", optionLabel:'JP - JAPAN'},
    { optionValue: "JE", optionLabel:'JE - JERSEY'},
    { optionValue: "JO", optionLabel:'JO - JORDAN'},
    { optionValue: "KZ", optionLabel:'KZ - KAZAKHSTAN'},
    { optionValue: "KE", optionLabel:'KE - KENYA'},
    { optionValue: "KI", optionLabel:'KI - KIRIBATI'},
    { optionValue: "KP", optionLabel:"KP - KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF"},
    { optionValue: "KR", optionLabel:'KR - KOREA, REPUBLIC OF'},
    { optionValue: "KW", optionLabel:'KW - KUWAIT'},
    { optionValue: "KG", optionLabel:'KG - KYRGYZSTAN'},
    { optionValue: "XE", optionLabel:'XE - LAKE LUGANO'},
    { optionValue: "LA", optionLabel:"LA - LAO PEOPLE'S DEMOCRATIC REPUBLIC"},
    { optionValue: "LB", optionLabel:'LB - LEBANON'},
    { optionValue: "LS", optionLabel:'LS - LESOTHO'},
    { optionValue: "LR", optionLabel:'LR - LIBERIA'},
    { optionValue: "LY", optionLabel:'LY - LIBYAN ARAB JAMAHIRIYA'},
    { optionValue: "LI", optionLabel:'LI - LIECHTENSTEIN'},
    { optionValue: "XF", optionLabel:'XF - LIVIGNO'},
    { optionValue: "MO", optionLabel:'MO - MACAO'},
    { optionValue: "MK", optionLabel:'MK - MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'},
    { optionValue: "MG", optionLabel:'MG - MADAGASCAR'},
    { optionValue: "MW", optionLabel:'MW - MALAWI'},
    { optionValue: "MY", optionLabel:'MY - MALAYSIA'},
    { optionValue: "MV", optionLabel:'MV - MALDIVES'},
    { optionValue: "ML", optionLabel:'ML - MALI'},
    { optionValue: "MH", optionLabel:'MH - MARSHALL ISLANDS'},
    { optionValue: "MQ", optionLabel:'MQ - MARTINIQUE'},
    { optionValue: "MR", optionLabel:'MR - MAURITANIA'},
    { optionValue: "MU", optionLabel:'MU - MAURITIUS'},
    { optionValue: "YT", optionLabel:'YT - MAYOTTE'},
    { optionValue: "XL", optionLabel:'XL - MELILLA'},
    { optionValue: "MX", optionLabel:'MX - MEXICO'},
    { optionValue: "FM", optionLabel:'FM - MICRONESIA, FEDERATED STATES OF'},
    { optionValue: "MD", optionLabel:'MD - MOLDOVA, REPUBLIC OF'},
    { optionValue: "MC", optionLabel:'MC - MONACO'},
    { optionValue: "MN", optionLabel:'MN - MONGOLIA'},
    { optionValue: "ME", optionLabel:'ME - MONTENEGRO'},
    { optionValue: "MS", optionLabel:'MS - MONTSERRAT'},
    { optionValue: "MA", optionLabel:'MA - MOROCCO'},
    { optionValue: "XM", optionLabel:'XM - MOUNT ATHOS'},
    { optionValue: "MZ", optionLabel:'MZ - MOZAMBIQUE'},
    { optionValue: "MM", optionLabel:'MM - MYANMAR'},
    { optionValue: "NA", optionLabel:'NA - NAMIBIA'},
    { optionValue: "NR", optionLabel:'NR - NAURU'},
    { optionValue: "NP", optionLabel:'NP - NEPAL'},
    { optionValue: "NC", optionLabel:'NC - NEW CALEDONIA'},
    { optionValue: "NZ", optionLabel:'NZ - NEW ZEALAND'},
    { optionValue: "NI", optionLabel:'NI - NICARAGUA'},
    { optionValue: "NE", optionLabel:'NE - NIGER'},
    { optionValue: "NG", optionLabel:'NG - NIGERIA'},
    { optionValue: "NU", optionLabel:'NU - NIUE'},
    { optionValue: "NF", optionLabel:'NF - NORFOLK ISLAND'},
    { optionValue: "XI", optionLabel:'XI - NORTHERN IRELAND'},
    { optionValue: "MP", optionLabel:'MP - NORTHERN MARIANA ISLANDS'},
    { optionValue: "NO", optionLabel:'NO - NORWAY'},
    { optionValue: "OM", optionLabel:'OM - OMAN'},
    { optionValue: "PK", optionLabel:'PK - PAKISTAN'},
    { optionValue: "PW", optionLabel:'PW - PALAU'},
    { optionValue: "PS", optionLabel:'PS - PALESTINIAN TERRITORY, OCCUPIED'},
    { optionValue: "PA", optionLabel:'PA - PANAMA'},
    { optionValue: "PG", optionLabel:'PG - PAPUA NEW GUINEA'},
    { optionValue: "PY", optionLabel:'PY - PARAGUAY'},
    { optionValue: "PE", optionLabel:'PE - PERU'},
    { optionValue: "PH", optionLabel:'PH - PHILIPPINES'},
    { optionValue: "PN", optionLabel:'PN - PITCAIRN'},
    { optionValue: "PR", optionLabel:'PR - PUERTO RICO'},
    { optionValue: "QA", optionLabel:'QA - QATAR'},
    { optionValue: "RE", optionLabel:'RE - REUNION'},
    { optionValue: "RU", optionLabel:'RU - RUSSIAN FEDERATION'},
    { optionValue: "RW", optionLabel:'RW - RWANDA'},
    { optionValue: "BL", optionLabel:'BL - SAINT BARTHÉLEMY'},
    { optionValue: "SH", optionLabel:'SH - SAINT HELENA'},
    { optionValue: "KN", optionLabel:'KN - SAINT KITTS AND NEVIS'},
    { optionValue: "LC", optionLabel:'LC - SAINT LUCIA'},
    { optionValue: "MF", optionLabel:'MF - SAINT MARTIN'},
    { optionValue: "SX", optionLabel:'SX - SAINT MARTIN (DUTCH PART)'},
    { optionValue: "PM", optionLabel:'PM - SAINT PIERRE AND MIQUELON'},
    { optionValue: "VC", optionLabel:'VC - SAINT VINCENT AND THE GRENADINES'},
    { optionValue: "WS", optionLabel:'WS - SAMOA'},
    { optionValue: "SM", optionLabel:'SM - SAN MARINO'},
    { optionValue: "ST", optionLabel:'ST - SAO TOME AND PRINCIPE'},
    { optionValue: "XH", optionLabel:'XH - SARK'},
    { optionValue: "SA", optionLabel:'SA - SAUDI ARABIA'},
    { optionValue: "SN", optionLabel:'SN - SENEGAL'},
    { optionValue: "RS", optionLabel:'RS - SERBIA'},
    { optionValue: "SC", optionLabel:'SC - SEYCHELLES'},
    { optionValue: "SL", optionLabel:'SL - SIERRA LEONE'},
    { optionValue: "SG", optionLabel:'SG - SINGAPORE'},
    { optionValue: "SB", optionLabel:'SB - SOLOMON ISLANDS'},
    { optionValue: "SO", optionLabel:'SO - SOMALIA'},
    { optionValue: "ZA", optionLabel:'ZA - SOUTH AFRICA'},
    { optionValue: "GS", optionLabel:'GS - SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'},
    { optionValue: "SS", optionLabel:'SS - SOUTH SUDAN'},
    { optionValue: "LK", optionLabel:'LK - SRI LANKA'},
    { optionValue: "SD", optionLabel:'SD - SUDAN'},
    { optionValue: "SR", optionLabel:'SR - SURINAME'},
    { optionValue: "SJ", optionLabel:'SJ - SVALBARD AND JAN MAYEN'},
    { optionValue: "SZ", optionLabel:'SZ - SWAZILAND'},
    { optionValue: "CH", optionLabel:'CH - SWITZERLAND'},
    { optionValue: "SY", optionLabel:'SY - SYRIAN ARAB REPUBLIC'},
    { optionValue: "TW", optionLabel:'TW - TAIWAN, PROVINCE OF CHINA'},
    { optionValue: "TJ", optionLabel:'TJ - TAJIKISTAN'},
    { optionValue: "TZ", optionLabel:'TZ - TANZANIA, UNITED REPUBLIC OF'},
    { optionValue: "TH", optionLabel:'TH - THAILAND'},
    { optionValue: "TL", optionLabel:'TL - TIMOR-LESTE'},
    { optionValue: "TG", optionLabel:'TG - TOGO'},
    { optionValue: "TK", optionLabel:'TK - TOKELAU'},
    { optionValue: "TO", optionLabel:'TO - TONGA'},
    { optionValue: "TT", optionLabel:'TT - TRINIDAD AND TOBAGO'},
    { optionValue: "TN", optionLabel:'TN - TUNISIA'},
    { optionValue: "TR", optionLabel:'TR - TURKEY'},
    { optionValue: "TM", optionLabel:'TM - TURKMENISTAN'},
    { optionValue: "TC", optionLabel:'TC - TURKS AND CAICOS ISLANDS'},
    { optionValue: "TV", optionLabel:'TV - TUVALU'},
    { optionValue: "UG", optionLabel:'UG - UGANDA'},
    { optionValue: "UA", optionLabel:'UA - UKRAINE'},
    { optionValue: "AE", optionLabel:'AE - UNITED ARAB EMIRATES'},
    { optionValue: "XU", optionLabel:'XU - UNITED KINGDOM without Northern Ireland'},
    { optionValue: "US", optionLabel:'US - UNITED STATES'},
    { optionValue: "UM", optionLabel:'UM - UNITED STATES MINOR OUTLYING ISLANDS'},
    { optionValue: "UY", optionLabel:'UY - URUGUAY'},
    { optionValue: "UZ", optionLabel:'UZ - UZBEKISTAN'},
    { optionValue: "VU", optionLabel:'VU - VANUATU'},
    { optionValue: "VE", optionLabel:'VE - VENEZUELA, BOLIVARIAN REPUBLIC OF'},
    { optionValue: "VN", optionLabel:'VN - VIET NAM'},
    { optionValue: "VG", optionLabel:'VG - VIRGIN ISLANDS, BRITISH'},
    { optionValue: "VI", optionLabel:'VI - VIRGIN ISLANDS, U.S.'},
    { optionValue: "WF", optionLabel:'WF - WALLIS AND FUTUNA'},
    { optionValue: "EH", optionLabel:'EH - WESTERN SAHARA'},
    { optionValue: "YE", optionLabel:'YE - YEMEN'},
    { optionValue: "ZM", optionLabel:'ZM - ZAMBIA'},
    { optionValue: "ZW", optionLabel:'ZW - ZIMBABWE'}
]

export const listaStatiOtherId =
            [
                { optionValue: "AF", optionLabel: "AF - AFGHANISTAN" },
                { optionValue: "AX", optionLabel: "AX - ÅLAND ISLANDS" },
                { optionValue: "AL", optionLabel: "AL - ALBANIA" },
                { optionValue: "DZ", optionLabel: "DZ - ALGERIA" },
                { optionValue: "AS", optionLabel: "AS - AMERICAN SAMOA" },
                { optionValue: "AD", optionLabel: "AD - ANDORRA" },
                { optionValue: "AO", optionLabel: "AO - ANGOLA" },
                { optionValue: "AI", optionLabel: "AI - ANGUILLA" },
                { optionValue: "AQ", optionLabel: "AQ - ANTARCTICA" },
                { optionValue: "AG", optionLabel: "AG - ANTIGUA AND BARBUDA" },
                { optionValue: "AR", optionLabel: "AR - ARGENTINA" },
                { optionValue: "AM", optionLabel: "AM - ARMENIA" },
                { optionValue: "AW", optionLabel: "AW - ARUBA" },
                { optionValue: "AU", optionLabel: "AU - AUSTRALIA" },
                { optionValue: "AZ", optionLabel: "AZ - AZERBAIJAN" },
                { optionValue: "BS", optionLabel: "BS - BAHAMAS" },
                { optionValue: "BH", optionLabel: "BH - BAHRAIN" },
                { optionValue: "BD", optionLabel: "BD - BANGLADESH" },
                { optionValue: "BB", optionLabel: "BB - BARBADOS" },
                { optionValue: "BY", optionLabel: "BY - BELARUS" },
                { optionValue: "BZ", optionLabel: "BZ - BELIZE" },
                { optionValue: "BJ", optionLabel: "BJ - BENIN" },
                { optionValue: "BM", optionLabel: "BM - BERMUDA" },
                { optionValue: "BT", optionLabel: "BT - BHUTAN" },
                { optionValue: "BO", optionLabel: "BO - BOLIVIA" },
                { optionValue: "BQ", optionLabel: "BQ - BONAIRE, SAINT EUSTATIUS AND SABA" },
                { optionValue: "BA", optionLabel: "BA - BOSNIA AND HERZEGOVINA" },
                { optionValue: "BW", optionLabel: "BW - BOTSWANA" },
                { optionValue: "BV", optionLabel: "BV - BOUVET ISLAND" },
                { optionValue: "BR", optionLabel: "BR - BRAZIL" },
                { optionValue: "IO", optionLabel: "IO - BRITISH INDIAN OCEAN TERRITORY" },
                { optionValue: "BN", optionLabel: "BN - BRUNEI DARUSSALAM" },
                { optionValue: "BF", optionLabel: "BF - BURKINA FASO" },
                { optionValue: "BI", optionLabel: "BI - BURUNDI" },
                { optionValue: "KH", optionLabel: "KH - CAMBODIA" },
                { optionValue: "CM", optionLabel: "CM - CAMEROON" },
                { optionValue: "CA", optionLabel: "CA - CANADA" },
                { optionValue: "IC", optionLabel: "IC - CANARY ISLANDS" },
                { optionValue: "CV", optionLabel: "CV - CAPE VERDE" },
                { optionValue: "KY", optionLabel: "KY - CAYMAN ISLANDS" },
                { optionValue: "CF", optionLabel: "CF - CENTRAL AFRICAN REPUBLIC" },
                { optionValue: "TD", optionLabel: "TD - CHAD" },
                { optionValue: "CL", optionLabel: "CL - CHILE" },
                { optionValue: "CN", optionLabel: "CN - CHINA" },
                { optionValue: "CX", optionLabel: "CX - CHRISTMAS ISLAND" },
                { optionValue: "CC", optionLabel: "CC - COCOS (KEELING) ISLANDS" },
                { optionValue: "CO", optionLabel: "CO - COLOMBIA" },
                { optionValue: "KM", optionLabel: "KM - COMOROS" },
                { optionValue: "CG", optionLabel: "CG - CONGO" },
                { optionValue: "CD", optionLabel: "CD - CONGO, THE DEMOCRATIC REPUBLIC OF THE" },
                { optionValue: "CK", optionLabel: "CK - COOK ISLANDS" },
                { optionValue: "CR", optionLabel: "CR - COSTA RICA" },
                { optionValue: "CI", optionLabel: "CI - COTE D'IVOIRE" },
                { optionValue: "CU", optionLabel: "CU - CUBA" },
                { optionValue: "CW", optionLabel: "CW - CURACAO" },
                { optionValue: "DJ", optionLabel: "DJ - DJIBOUTI" },
                { optionValue: "DM", optionLabel: "DM - DOMINICA" },
                { optionValue: "DO", optionLabel: "DO - DOMINICAN REPUBLIC" },
                { optionValue: "EC", optionLabel: "EC - ECUADOR" },
                { optionValue: "EG", optionLabel: "EG - EGYPT" },
                { optionValue: "SV", optionLabel: "SV - EL SALVADOR" },
                { optionValue: "GQ", optionLabel: "GQ - EQUATORIAL GUINEA" },
                { optionValue: "ER", optionLabel: "ER - ERITREA" },
                { optionValue: "ET", optionLabel: "ET - ETHIOPIA" },
                { optionValue: "FK", optionLabel: "FK - FALKLAND ISLANDS (MALVINAS)" },
                { optionValue: "FO", optionLabel: "FO - FAROE ISLANDS" },
                { optionValue: "FJ", optionLabel: "FJ - FIJI" },
                { optionValue: "GF", optionLabel: "GF - FRENCH GUIANA" },
                { optionValue: "PF", optionLabel: "PF - FRENCH POLYNESIA" },
                { optionValue: "TF", optionLabel: "TF - FRENCH SOUTHERN TERRITORIES" },
                { optionValue: "GA", optionLabel: "GA - GABON" },
                { optionValue: "GM", optionLabel: "GM - GAMBIA" },
                { optionValue: "GE", optionLabel: "GE - GEORGIA" },
                { optionValue: "GH", optionLabel: "GH - GHANA" },
                { optionValue: "GI", optionLabel: "GI - GIBRALTAR" },
                { optionValue: "GL", optionLabel: "GL - GREENLAND" },
                { optionValue: "GD", optionLabel: "GD - GRENADA" },
                { optionValue: "GP", optionLabel: "GP - GUADELOUPE" },
                { optionValue: "GU", optionLabel: "GU - GUAM" },
                { optionValue: "GT", optionLabel: "GT - GUATEMALA" },
                { optionValue: "GG", optionLabel: "GG - GUERNSEY" },
                { optionValue: "GN", optionLabel: "GN - GUINEA" },
                { optionValue: "GW", optionLabel: "GW - GUINEA-BISSAU" },
                { optionValue: "GY", optionLabel: "GY - GUYANA" },
                { optionValue: "HT", optionLabel: "HT - HAITI" },
                { optionValue: "HM", optionLabel: "HM - HEARD ISLAND AND MCDONALD ISLANDS" },
                { optionValue: "VA", optionLabel: "VA - HOLY SEE (VATICAN CITY STATE)" },
                { optionValue: "HN", optionLabel: "HN - HONDURAS" },
                { optionValue: "HK", optionLabel: "HK - HONG KONG" },
                { optionValue: "IS", optionLabel: "IS - ICELAND" },
                { optionValue: "IN", optionLabel: "IN - INDIA" },
                { optionValue: "ID", optionLabel: "ID - INDONESIA" },
                { optionValue: "IR", optionLabel: "IR - IRAN, ISLAMIC REPUBLIC OF" },
                { optionValue: "IQ", optionLabel: "IQ - IRAQ" },
                { optionValue: "IM", optionLabel: "IM - ISLE OF MAN" },
                { optionValue: "IL", optionLabel: "IL - ISRAEL" },
                { optionValue: "JM", optionLabel: "JM - JAMAICA" },
                { optionValue: "JP", optionLabel: "JP - JAPAN" },
                { optionValue: "JE", optionLabel: "JE - JERSEY" },
                { optionValue: "JO", optionLabel: "JO - JORDAN" },
                { optionValue: "KZ", optionLabel: "KZ - KAZAKHSTAN" },
                { optionValue: "KE", optionLabel: "KE - KENYA" },
                { optionValue: "KI", optionLabel: "KI - KIRIBATI" },
                { optionValue: "KP", optionLabel: "KP - KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
                { optionValue: "KR", optionLabel: "KR - KOREA, REPUBLIC OF" },
                { optionValue: "KW", optionLabel: "KW - KUWAIT" },
                { optionValue: "KG", optionLabel: "KG - KYRGYZSTAN" },
                { optionValue: "LA", optionLabel: "LA - LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
                { optionValue: "LB", optionLabel: "LB - LEBANON" },
                { optionValue: "LS", optionLabel: "LS - LESOTHO" },
                { optionValue: "LR", optionLabel: "LR - LIBERIA" },
                { optionValue: "LY", optionLabel: "LY - LIBYAN ARAB JAMAHIRIYA" },
                { optionValue: "LI", optionLabel: "LI - LIECHTENSTEIN" },
                { optionValue: "MO", optionLabel: "MO - MACAO" },
                { optionValue: "MK", optionLabel: "MK - MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF" },
                { optionValue: "MG", optionLabel: "MG - MADAGASCAR" },
                { optionValue: "MW", optionLabel: "MW - MALAWI" },
                { optionValue: "MY", optionLabel: "MY - MALAYSIA" },
                { optionValue: "MV", optionLabel: "MV - MALDIVES" },
                { optionValue: "ML", optionLabel: "ML - MALI" },
                { optionValue: "MH", optionLabel: "MH - MARSHALL ISLANDS" },
                { optionValue: "MQ", optionLabel: "MQ - MARTINIQUE" },
                { optionValue: "MR", optionLabel: "MR - MAURITANIA" },
                { optionValue: "MU", optionLabel: "MU - MAURITIUS" },
                { optionValue: "YT", optionLabel: "YT - MAYOTTE" },
                { optionValue: "MX", optionLabel: "MX - MEXICO" },
                { optionValue: "FM", optionLabel: "FM - MICRONESIA, FEDERATED STATES OF" },
                { optionValue: "MD", optionLabel: "MD - MOLDOVA, REPUBLIC OF" },
                { optionValue: "MC", optionLabel: "MC - MONACO" },
                { optionValue: "MN", optionLabel: "MN - MONGOLIA" },
                { optionValue: "ME", optionLabel: "ME - MONTENEGRO" },
                { optionValue: "MS", optionLabel: "MS - MONTSERRAT" },
                { optionValue: "MA", optionLabel: "MA - MOROCCO" },
                { optionValue: "MZ", optionLabel: "MZ - MOZAMBIQUE" },
                { optionValue: "MM", optionLabel: "MM - MYANMAR" },
                { optionValue: "NA", optionLabel: "NA - NAMIBIA" },
                { optionValue: "NR", optionLabel: "NR - NAURU" },
                { optionValue: "NP", optionLabel: "NP - NEPAL" },
                { optionValue: "NC", optionLabel: "NC - NEW CALEDONIA" },
                { optionValue: "NZ", optionLabel: "NZ - NEW ZEALAND" },
                { optionValue: "NI", optionLabel: "NI - NICARAGUA" },
                { optionValue: "NE", optionLabel: "NE - NIGER" },
                { optionValue: "NG", optionLabel: "NG - NIGERIA" },
                { optionValue: "NU", optionLabel: "NU - NIUE" },
                { optionValue: "NF", optionLabel: "NF - NORFOLK ISLAND" },
                { optionValue: "MP", optionLabel: "MP - NORTHERN MARIANA ISLANDS" },
                { optionValue: "NO", optionLabel: "NO - NORWAY" },
                { optionValue: "OM", optionLabel: "OM - OMAN" },
                { optionValue: "PK", optionLabel: "PK - PAKISTAN" },
                { optionValue: "PW", optionLabel: "PW - PALAU" },
                { optionValue: "PS", optionLabel: "PS - PALESTINIAN TERRITORY, OCCUPIED" },
                { optionValue: "PA", optionLabel: "PA - PANAMA" },
               { optionValue: "PG", optionLabel: "PG - PAPUA NEW GUINEA" },
                { optionValue: "PY", optionLabel: "PY - PARAGUAY" },
                { optionValue: "PE", optionLabel: "PE - PERU" },
                { optionValue: "PH", optionLabel: "PH - PHILIPPINES" },
                { optionValue: "PN", optionLabel: "PN - PITCAIRN" },
                { optionValue: "PR", optionLabel: "PR - PUERTO RICO" },
                { optionValue: "QA", optionLabel: "QA - QATAR" },
                { optionValue: "RE", optionLabel: "RE - REUNION" },
                { optionValue: "RU", optionLabel: "RU - RUSSIAN FEDERATION" },
                { optionValue: "RW", optionLabel: "RW - RWANDA" },
                { optionValue: "BL", optionLabel: "BL - SAINT BARTHÉLEMY" },
                { optionValue: "SH", optionLabel: "SH - SAINT HELENA" },
                { optionValue: "KN", optionLabel: "KN - SAINT KITTS AND NEVIS" },
                { optionValue: "LC", optionLabel: "LC - SAINT LUCIA" },
                { optionValue: "MF", optionLabel: "MF - SAINT MARTIN" },
                { optionValue: "SX", optionLabel: "SX - SAINT MARTIN (DUTCH PART)" },
                { optionValue: "PM", optionLabel: "PM - SAINT PIERRE AND MIQUELON" },
                { optionValue: "VC", optionLabel: "VC - SAINT VINCENT AND THE GRENADINES" },
                { optionValue: "WS", optionLabel: "WS - SAMOA" },
                { optionValue: "SM", optionLabel: "SM - SAN MARINO" },
                { optionValue: "ST", optionLabel: "ST - SAO TOME AND PRINCIPE" },
                { optionValue: "SA", optionLabel: "SA - SAUDI ARABIA" },
                { optionValue: "SN", optionLabel: "SN - SENEGAL" },
                { optionValue: "RS", optionLabel: "RS - SERBIA" },
                { optionValue: "SC", optionLabel: "SC - SEYCHELLES" },
                { optionValue: "SL", optionLabel: "SL - SIERRA LEONE" },
                { optionValue: "SG", optionLabel: "SG - SINGAPORE" },
                { optionValue: "SB", optionLabel: "SB - SOLOMON ISLANDS" },
                { optionValue: "SO", optionLabel: "SO - SOMALIA" },
                { optionValue: "ZA", optionLabel: "ZA - SOUTH AFRICA" },
                { optionValue: "GS", optionLabel: "GS - SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS" },
                { optionValue: "SS", optionLabel: "SS - SOUTH SUDAN" },
                { optionValue: "LK", optionLabel: "LK - SRI LANKA" },
                { optionValue: "SD", optionLabel: "SD - SUDAN" },
                { optionValue: "SR", optionLabel: "SR - SURINAME" },
                { optionValue: "SJ", optionLabel: "SJ - SVALBARD AND JAN MAYEN" },
                { optionValue: "SZ", optionLabel: "SZ - SWAZILAND" },
                { optionValue: "CH", optionLabel: "CH - SWITZERLAND" },
                { optionValue: "SY", optionLabel: "SY - SYRIAN ARAB REPUBLIC" },
                { optionValue: "TW", optionLabel: "TW - TAIWAN, PROVINCE OF CHINA" },
                { optionValue: "TJ", optionLabel: "TJ - TAJIKISTAN" },
                { optionValue: "TZ", optionLabel: "TZ - TANZANIA, UNITED REPUBLIC OF" },
                { optionValue: "TH", optionLabel: "TH - THAILAND" },
                { optionValue: "TL", optionLabel: "TL - TIMOR-LESTE" },
                { optionValue: "TG", optionLabel: "TG - TOGO" },
                { optionValue: "TK", optionLabel: "TK - TOKELAU" },
                { optionValue: "TO", optionLabel: "TO - TONGA" },
                { optionValue: "TT", optionLabel: "TT - TRINIDAD AND TOBAGO" },
                { optionValue: "TN", optionLabel: "TN - TUNISIA" },
                { optionValue: "TR", optionLabel: "TR - TURKEY" },
                { optionValue: "TM", optionLabel: "TM - TURKMENISTAN" },
                { optionValue: "TC", optionLabel: "TC - TURKS AND CAICOS ISLANDS" },
                { optionValue: "TV", optionLabel: "TV - TUVALU" },
                { optionValue: "UG", optionLabel: "UG - UGANDA" },
                { optionValue: "UA", optionLabel: "UA - UKRAINE" },
                { optionValue: "AE", optionLabel: "AE - UNITED ARAB EMIRATES" },
                { optionValue: "GB", optionLabel: "GB - UNITED KINGDOM" },
                { optionValue: "US", optionLabel: "US - UNITED STATES" },
                { optionValue: "UM", optionLabel: "UM - UNITED STATES MINOR OUTLYING ISLANDS" },
                { optionValue: "UY", optionLabel: "UY - URUGUAY" },
                { optionValue: "UZ", optionLabel: "UZ - UZBEKISTAN" },
                { optionValue: "VU", optionLabel: "VU - VANUATU" },
                { optionValue: "VE", optionLabel: "VE - VENEZUELA, BOLIVARIAN REPUBLIC OF" },
                { optionValue: "VN", optionLabel: "VN - VIET NAM" },
                { optionValue: "VG", optionLabel: "VG - VIRGIN ISLANDS, BRITISH" },
                { optionValue: "VI", optionLabel: "VI - VIRGIN ISLANDS, U.S." },
                { optionValue: "WF", optionLabel: "WF - WALLIS AND FUTUNA" },
                { optionValue: "EH", optionLabel: "EH - WESTERN SAHARA" },
                { optionValue: "YE", optionLabel: "YE - YEMEN" },
                { optionValue: "ZM", optionLabel: "ZM - ZAMBIA" },
                { optionValue: "ZW", optionLabel: "ZW - ZIMBABWE" }
]

export const listaStatiUeEng = [
    { optionValue: "AT", optionLabel: "AT - Austria" },
    { optionValue: "BE", optionLabel: "BE - Belgium" },
    { optionValue: "BG", optionLabel: "BG - Bulgaria" },
    { optionValue: "CY", optionLabel: "CY - Cyprus" },
    { optionValue: "HR", optionLabel: "HR - Croatia" },
    { optionValue: "CZ", optionLabel: "CZ - Czech republic" },
    { optionValue: "DK", optionLabel: "DK - Denmark" },
    { optionValue: "EE", optionLabel: "EE - Estonia" },
    { optionValue: "FI", optionLabel: "FI - Finland" },
    { optionValue: "FR", optionLabel: "FR - France" },
    { optionValue: "DE", optionLabel: "DE - Germany" },
    { optionValue: "EL", optionLabel: "EL - Greece" },
    { optionValue: "HU", optionLabel: "HU - Hungary" },
    { optionValue: "IE", optionLabel: "IE - Ireland" },
    { optionValue: "LT", optionLabel: "LT - Latvia" },
    { optionValue: "LV", optionLabel: "LV - Lithuania" },
    { optionValue: "LU", optionLabel: "LU - Luxembourg" },
    { optionValue: "MT", optionLabel: "MT - Malta" },
    { optionValue: "NL", optionLabel: "NL - Netherlands" },
    { optionValue: "PL", optionLabel: "PL - Poland" },
    { optionValue: "PT", optionLabel: "PT - Portugal" },
    { optionValue: "RO", optionLabel: "RO - Romania" },
    { optionValue: "SK", optionLabel: "SK - Slovakia" },
    { optionValue: "SI", optionLabel: "SI - Slovenia" },
    { optionValue: "ES", optionLabel: "ES - Spain" },
    { optionValue: "SE", optionLabel: "SE - Sweden" }
]

export const listaStatiUE = [
    { optionValue: "AT", optionLabel: "AT - Austria" },
    { optionValue: "BE", optionLabel: "BE - Belgio" },
    { optionValue: "BG", optionLabel: "BG - Bulgaria" },
    { optionValue: "CY", optionLabel: "CY - Cipro" },
    { optionValue: "HR", optionLabel: "HR - Croazia" },
    { optionValue: "DK", optionLabel: "DK - Danimarca" },
    { optionValue: "EE", optionLabel: "EE - Estonia" },
    { optionValue: "FI", optionLabel: "FI - Finlandia" },
    { optionValue: "FR", optionLabel: "FR - Francia" },
    { optionValue: "DE", optionLabel: "DE - Germania" },
    { optionValue: "EL", optionLabel: "EL - Grecia" },
    { optionValue: "IE", optionLabel: "IE - Irlanda" },
    { optionValue: "IT", optionLabel: "IT - Italia" },
    { optionValue: "LT", optionLabel: "LT - Lettonia" },
    { optionValue: "LV", optionLabel: "LV - Lituania" },
    { optionValue: "LU", optionLabel: "LU - Lussemburgo" },
    { optionValue: "MT", optionLabel: "MT - Malta" },
    { optionValue: "NL", optionLabel: "NL - Paesi bassi" },
    { optionValue: "PL", optionLabel: "PL - Polonia" },
    { optionValue: "PT", optionLabel: "PT - Portogallo" },
    { optionValue: "CZ", optionLabel: "CZ - Repubblica ceca" },
    { optionValue: "RO", optionLabel: "RO - Romania" },
    { optionValue: "SK", optionLabel: "SK - Slovacchia" },
    { optionValue: "SI", optionLabel: "SI - Slovenia" },
    { optionValue: "ES", optionLabel: "ES - Spagna" },
    { optionValue: "SE", optionLabel: "SE - Svezia" },
    { optionValue: "HU", optionLabel: "HU - Ungheria" }
]

/* new */
export const listaNascitaIndir = [
    { optionValue: "", optionLabel: '' },
    { optionValue: "AF", optionLabel: 'AF - AFGHANISTAN' },
    { optionValue: "AX", optionLabel: 'AX - ÅLAND ISLANDS' },
    { optionValue: "AL", optionLabel: 'AL - ALBANIA' },
    { optionValue: "DZ", optionLabel: 'DZ - ALGERIA' },
    { optionValue: "AS", optionLabel: 'AS - AMERICAN SAMOA' },
    { optionValue: "AD", optionLabel: 'AD - ANDORRA' },
    { optionValue: "AO", optionLabel: 'AO - ANGOLA' },
    { optionValue: "AI", optionLabel: 'AI - ANGUILLA' },
    { optionValue: "AQ", optionLabel: 'AQ - ANTARCTICA' },
    { optionValue: "AG", optionLabel: 'AG - ANTIGUA AND BARBUDA' },
    { optionValue: "AR", optionLabel: 'AR - ARGENTINA' },
    { optionValue: "AM", optionLabel: 'AM - ARMENIA' },
    { optionValue: "AW", optionLabel: 'AW - ARUBA' },
    { optionValue: "AU", optionLabel: 'AU - AUSTRALIA' },
    { optionValue: "AT", optionLabel: 'AT - AUSTRIA' },
    { optionValue: "AZ", optionLabel: 'AZ - AZERBAIJAN' },
    { optionValue: "BS", optionLabel: 'BS - BAHAMAS' },
    { optionValue: "BH", optionLabel: 'BH - BAHRAIN' },
    { optionValue: "BD", optionLabel: 'BD - BANGLADESH' },
    { optionValue: "BB", optionLabel: 'BB - BARBADOS' },
    { optionValue: "BY", optionLabel: 'BY - BELARUS' },
    { optionValue: "BE", optionLabel: 'BE - BELGIUM' },
    { optionValue: "BZ", optionLabel: 'BZ - BELIZE' },
    { optionValue: "BJ", optionLabel: 'BJ - BENIN' },
    { optionValue: "BM", optionLabel: 'BM - BERMUDA' },
    { optionValue: "BT", optionLabel: 'BT - BHUTAN' },
    { optionValue: "BO", optionLabel: 'BO - BOLIVIA' },
    { optionValue: "BA", optionLabel: 'BA - BOSNIA AND HERZEGOVINA' },
    { optionValue: "BW", optionLabel: 'BW - BOTSWANA' },
    { optionValue: "BV", optionLabel: 'BV - BOUVET ISLAND' },
    { optionValue: "BR", optionLabel: 'BR - BRAZIL' },
    { optionValue: "IO", optionLabel: 'IO - BRITISH INDIAN OCEAN TERRITORY' },
    { optionValue: "BN", optionLabel: 'BN - BRUNEI DARUSSALAM' },
    { optionValue: "BG", optionLabel: 'BG - BULGARIA' },
    { optionValue: "BF", optionLabel: 'BF - BURKINA FASO' },
    { optionValue: "BI", optionLabel: 'BI - BURUNDI' },
    { optionValue: "KH", optionLabel: 'KH - CAMBODIA' },
    { optionValue: "CM", optionLabel: 'CM - CAMEROON' },
    { optionValue: "CA", optionLabel: 'CA - CANADA' },
    { optionValue: "CV", optionLabel: 'CV - CAPE VERDE' },
    { optionValue: "KY", optionLabel: 'KY - CAYMAN ISLANDS' },
    { optionValue: "CF", optionLabel: 'CF - CENTRAL AFRICAN REPUBLIC' },
    { optionValue: "TD", optionLabel: 'TD - CHAD' },
    { optionValue: "CL", optionLabel: 'CL - CHILE' },
    { optionValue: "CN", optionLabel: 'CN - CHINA' },
    { optionValue: "CX", optionLabel: 'CX - CHRISTMAS ISLAND' },
    { optionValue: "CC", optionLabel: 'CC - COCOS (KEELING) ISLANDS' },
    { optionValue: "CO", optionLabel: 'CO - COLOMBIA' },
    { optionValue: "KM", optionLabel: 'KM - COMOROS' },
    { optionValue: "CG", optionLabel: 'CG - CONGO' },
    { optionValue: "CD", optionLabel: 'CD - CONGO, THE DEMOCRATIC REPUBLIC OF THE' },
    { optionValue: "CK", optionLabel: 'CK - COOK ISLANDS' },
    { optionValue: "CR", optionLabel: 'CR - COSTA RICA' },
    { optionValue: "CI", optionLabel: "CI - COTE D'IVOIRE" },
    { optionValue: "HR", optionLabel: 'HR - CROATIA' },
    { optionValue: "CU", optionLabel: 'CU - CUBA' },
    { optionValue: "CY", optionLabel: 'CY - CYPRUS' },
    { optionValue: "CZ", optionLabel: 'CZ - CZECH REPUBLIC' },
    { optionValue: "DK", optionLabel: 'DK - DENMARK' },
    { optionValue: "DJ", optionLabel: 'DJ - DJIBOUTI' },
    { optionValue: "DM", optionLabel: 'DM - DOMINICA' },
    { optionValue: "DO", optionLabel: 'DO - DOMINICAN REPUBLIC' },
    { optionValue: "EC", optionLabel: 'EC - ECUADOR' },
    { optionValue: "EG", optionLabel: 'EG - EGYPT' },
    { optionValue: "SV", optionLabel: 'SV - EL SALVADOR' },
    { optionValue: "GQ", optionLabel: 'GQ - EQUATORIAL GUINEA' },
    { optionValue: "ER", optionLabel: 'ER - ERITREA' },
    { optionValue: "EE", optionLabel: 'EE - ESTONIA' },
    { optionValue: "ET", optionLabel: 'ET - ETHIOPIA' },
    { optionValue: "FK", optionLabel: 'FK - FALKLAND ISLANDS (MALVINAS)' },
    { optionValue: "FO", optionLabel: 'FO - FAROE ISLANDS' },
    { optionValue: "FJ", optionLabel: 'FJ - FIJI' },
    { optionValue: "FI", optionLabel: 'FI - FINLAND' },
    { optionValue: "FR", optionLabel: 'FR - FRANCE' },
    { optionValue: "GF", optionLabel: 'GF - FRENCH GUIANA' },
    { optionValue: "PF", optionLabel: 'PF - FRENCH POLYNESIA' },
    { optionValue: "TF", optionLabel: 'TF - FRENCH SOUTHERN TERRITORIES' },
    { optionValue: "GA", optionLabel: 'GA - GABON' },
    { optionValue: "GM", optionLabel: 'GM - GAMBIA' },
    { optionValue: "GE", optionLabel: 'GE - GEORGIA' },
    { optionValue: "DE", optionLabel: 'DE - GERMANY' },
    { optionValue: "GH", optionLabel: 'GH - GHANA' },
    { optionValue: "GI", optionLabel: 'GI - GIBRALTAR' },
    { optionValue: "GR", optionLabel: 'GR - GREECE' },
    { optionValue: "GL", optionLabel: 'GL - GREENLAND' },
    { optionValue: "GD", optionLabel: 'GD - GRENADA' },
    { optionValue: "GP", optionLabel: 'GP - GUADELOUPE' },
    { optionValue: "GU", optionLabel: 'GU - GUAM' },
    { optionValue: "GT", optionLabel: 'GT - GUATEMALA' },
    { optionValue: "GG", optionLabel: 'GG - GUERNSEY' },
    { optionValue: "GN", optionLabel: 'GN - GUINEA' },
    { optionValue: "GW", optionLabel: 'GW - GUINEA-BISSAU' },
    { optionValue: "GY", optionLabel: 'GY - GUYANA' },
    { optionValue: "HT", optionLabel: 'HT - HAITI' },
    { optionValue: "HM", optionLabel: 'HM - HEARD ISLAND AND MCDONALD ISLANDS' },
    { optionValue: "VA", optionLabel: 'VA - HOLY SEE (VATICAN CITY STATE)' },
    { optionValue: "HN", optionLabel: 'HN - HONDURAS' },
    { optionValue: "HK", optionLabel: 'HK - HONG KONG' },
    { optionValue: "HU", optionLabel: 'HU - HUNGARY' },
    { optionValue: "IS", optionLabel: 'IS - ICELAND' },
    { optionValue: "IN", optionLabel: 'IN - INDIA' },
    { optionValue: "ID", optionLabel: 'ID - INDONESIA' },
    { optionValue: "IR", optionLabel: 'IR - IRAN, ISLAMIC REPUBLIC OF' },
    { optionValue: "IQ", optionLabel: 'IQ - IRAQ' },
    { optionValue: "IE", optionLabel: 'IE - IRELAND' },
    { optionValue: "IL", optionLabel: 'IL - ISRAEL' },
    { optionValue: "IT", optionLabel: 'IT - ITALY' },
    { optionValue: "JM", optionLabel: 'JM - JAMAICA' },
    { optionValue: "JP", optionLabel: 'JP - JAPAN' },
    { optionValue: "JE", optionLabel: 'JE - JERSEY' },
    { optionValue: "JO", optionLabel: 'JO - JORDAN' },
    { optionValue: "KZ", optionLabel: 'KZ - KAZAKHSTAN' },
    { optionValue: "KE", optionLabel: 'KE - KENYA' },
    { optionValue: "KI", optionLabel: 'KI - KIRIBATI' },
    { optionValue: "KP", optionLabel: "KP - KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
    { optionValue: "KR", optionLabel: 'KR - KOREA, REPUBLIC OF' },
    { optionValue: "KW", optionLabel: 'KW - KUWAIT' },
    { optionValue: "KG", optionLabel: 'KG - KYRGYZSTAN' },
    { optionValue: "LA", optionLabel: "LA - LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
    { optionValue: "LV", optionLabel: 'LV - LATVIA' },
    { optionValue: "LB", optionLabel: 'LB - LEBANON' },
    { optionValue: "LS", optionLabel: 'LS - LESOTHO' },
    { optionValue: "LR", optionLabel: 'LR - LIBERIA' },
    { optionValue: "LY", optionLabel: 'LY - LIBYAN ARAB JAMAHIRIYA' },
    { optionValue: "LI", optionLabel: 'LI - LIECHTENSTEIN' },
    { optionValue: "LT", optionLabel: 'LT - LITHUANIA' },
    { optionValue: "LU", optionLabel: 'LU - LUXEMBOURG' },
    { optionValue: "MO", optionLabel: 'MO - MACAO' },
    { optionValue: "MK", optionLabel: 'MK - MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF' },
    { optionValue: "MG", optionLabel: 'MG - MADAGASCAR' },
    { optionValue: "MW", optionLabel: 'MW - MALAWI' },
    { optionValue: "MY", optionLabel: 'MY - MALAYSIA' },
    { optionValue: "MV", optionLabel: 'MV - MALDIVES' },
    { optionValue: "ML", optionLabel: 'ML - MALI' },
    { optionValue: "MT", optionLabel: 'MT - MALTA' },
    { optionValue: "MH", optionLabel: 'MH - MARSHALL ISLANDS' },
    { optionValue: "MQ", optionLabel: 'MQ - MARTINIQUE' },
    { optionValue: "MR", optionLabel: 'MR - MAURITANIA' },
    { optionValue: "MU", optionLabel: 'MU - MAURITIUS' },
    { optionValue: "YT", optionLabel: 'YT - MAYOTTE' },
    { optionValue: "MX", optionLabel: 'MX - MEXICO' },
    { optionValue: "FM", optionLabel: 'FM - MICRONESIA, FEDERATED STATES OF' },
    { optionValue: "MD", optionLabel: 'MD - MOLDOVA, REPUBLIC OF' },
    { optionValue: "MN", optionLabel: 'MN - MONGOLIA' },
    { optionValue: "ME", optionLabel: 'ME - MONTENEGRO' },
    { optionValue: "MS", optionLabel: 'MS - MONTSERRAT' },
    { optionValue: "MA", optionLabel: 'MA - MOROCCO' },
    { optionValue: "MZ", optionLabel: 'MZ - MOZAMBIQUE' },
    { optionValue: "MM", optionLabel: 'MM - MYANMAR' },
    { optionValue: "NA", optionLabel: 'NA - NAMIBIA' },
    { optionValue: "NR", optionLabel: 'NR - NAURU' },
    { optionValue: "NP", optionLabel: 'NP - NEPAL' },
    { optionValue: "NL", optionLabel: 'NL - NETHERLANDS' },
    { optionValue: "NC", optionLabel: 'NC - NEW CALEDONIA' },
    { optionValue: "NZ", optionLabel: 'NZ - NEW ZEALAND' },
    { optionValue: "NI", optionLabel: 'NI - NICARAGUA' },
    { optionValue: "NE", optionLabel: 'NE - NIGER' },
    { optionValue: "NG", optionLabel: 'NG - NIGERIA' },
    { optionValue: "NU", optionLabel: 'NU - NIUE' },
    { optionValue: "NF", optionLabel: 'NF - NORFOLK ISLAND' },
    { optionValue: "MP", optionLabel: 'MP - NORTHERN MARIANA ISLANDS' },
    { optionValue: "NO", optionLabel: 'NO - NORWAY' },
    { optionValue: "OM", optionLabel: 'OM - OMAN' },
    { optionValue: "PK", optionLabel: 'PK - PAKISTAN' },
    { optionValue: "PW", optionLabel: 'PW - PALAU' },
    { optionValue: "PS", optionLabel: 'PS - PALESTINIAN TERRITORY, OCCUPIED' },
    { optionValue: "PA", optionLabel: 'PA - PANAMA' },
    { optionValue: "PG", optionLabel: 'PG - PAPUA NEW GUINEA' },
    { optionValue: "PY", optionLabel: 'PY - PARAGUAY' },
    { optionValue: "PE", optionLabel: 'PE - PERU' },
    { optionValue: "PH", optionLabel: 'PH - PHILIPPINES' },
    { optionValue: "PN", optionLabel: 'PN - PITCAIRN' },
    { optionValue: "PL", optionLabel: 'PL - POLAND' },
    { optionValue: "PT", optionLabel: 'PT - PORTUGAL' },
    { optionValue: "PR", optionLabel: 'PR - PUERTO RICO' },
    { optionValue: "QA", optionLabel: 'QA - QATAR' },
    { optionValue: "RE", optionLabel: 'RE - REUNION' },
    { optionValue: "RO", optionLabel: 'RO - ROMANIA' },
    { optionValue: "RU", optionLabel: 'RU - RUSSIAN FEDERATION' },
    { optionValue: "RW", optionLabel: 'RW - RWANDA' },
    { optionValue: "BL", optionLabel: 'BL - SAINT BARTHÉLEMY' },
    { optionValue: "SH", optionLabel: 'SH - SAINT HELENA' },
    { optionValue: "KN", optionLabel: 'KN - SAINT KITTS AND NEVIS' },
    { optionValue: "LC", optionLabel: 'LC - SAINT LUCIA' },
    { optionValue: "MF", optionLabel: 'MF - SAINT MARTIN' },
    { optionValue: "PM", optionLabel: 'PM - SAINT PIERRE AND MIQUELON' },
    { optionValue: "VC", optionLabel: 'VC - SAINT VINCENT AND THE GRENADINES' },
    { optionValue: "WS", optionLabel: 'WS - SAMOA' },
    { optionValue: "SM", optionLabel: 'SM - SAN MARINO' },
    { optionValue: "ST", optionLabel: 'ST - SAO TOME AND PRINCIPE' },
    { optionValue: "SA", optionLabel: 'SA - SAUDI ARABIA' },
    { optionValue: "SN", optionLabel: 'SN - SENEGAL' },
    { optionValue: "RS", optionLabel: 'RS - SERBIA' },
    { optionValue: "SC", optionLabel: 'SC - SEYCHELLES' },
    { optionValue: "SL", optionLabel: 'SL - SIERRA LEONE' },
    { optionValue: "SG", optionLabel: 'SG - SINGAPORE' },
    { optionValue: "SK", optionLabel: 'SK - SLOVAKIA' },
    { optionValue: "SI", optionLabel: 'SI - SLOVENIA' },
    { optionValue: "SB", optionLabel: 'SB - SOLOMON ISLANDS' },
    { optionValue: "SO", optionLabel: 'SO - SOMALIA' },
    { optionValue: "ZA", optionLabel: 'ZA - SOUTH AFRICA' },
    { optionValue: "GS", optionLabel: 'GS - SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS' },
    { optionValue: "SS", optionLabel: 'SS - SOUTH SUDAN' },
    { optionValue: "ES", optionLabel: 'ES - SPAIN' },
    { optionValue: "LK", optionLabel: 'LK - SRI LANKA' },
    { optionValue: "SD", optionLabel: 'SD - SUDAN' },
    { optionValue: "SR", optionLabel: 'SR - SURINAME' },
    { optionValue: "SJ", optionLabel: 'SJ - SVALBARD AND JAN MAYEN' },
    { optionValue: "SZ", optionLabel: 'SZ - SWAZILAND' },
    { optionValue: "SE", optionLabel: 'SE - SWEDEN' },
    { optionValue: "CH", optionLabel: 'CH - SWITZERLAND' },
    { optionValue: "SY", optionLabel: 'SY - SYRIAN ARAB REPUBLIC' },
    { optionValue: "TW", optionLabel: 'TW - TAIWAN, PROVINCE OF CHINA' },
    { optionValue: "TJ", optionLabel: 'TJ - TAJIKISTAN' },
    { optionValue: "TZ", optionLabel: 'TZ - TANZANIA, UNITED REPUBLIC OF' },
    { optionValue: "TH", optionLabel: 'TH - THAILAND' },
    { optionValue: "TL", optionLabel: 'TL - TIMOR-LESTE' },
    { optionValue: "TG", optionLabel: 'TG - TOGO' },
    { optionValue: "TK", optionLabel: 'TK - TOKELAU' },
    { optionValue: "TO", optionLabel: 'TO - TONGA' },
    { optionValue: "TT", optionLabel: 'TT - TRINIDAD AND TOBAGO' },
    { optionValue: "TN", optionLabel: 'TN - TUNISIA' },
    { optionValue: "TR", optionLabel: 'TR - TURKEY' },
    { optionValue: "TM", optionLabel: 'TM - TURKMENISTAN' },
    { optionValue: "TC", optionLabel: 'TC - TURKS AND CAICOS ISLANDS' },
    { optionValue: "TV", optionLabel: 'TV - TUVALU' },
    { optionValue: "UG", optionLabel: 'UG - UGANDA' },
    { optionValue: "UA", optionLabel: 'UA - UKRAINE' },
    { optionValue: "AE", optionLabel: 'AE - UNITED ARAB EMIRATES' },
    { optionValue: "GB", optionLabel: 'GB - UNITED KINGDOM' },
    { optionValue: "US", optionLabel: 'US - UNITED STATES' },
    { optionValue: "UM", optionLabel: 'UM - UNITED STATES MINOR OUTLYING ISLANDS' },
    { optionValue: "UY", optionLabel: 'UY - URUGUAY' },
    { optionValue: "UZ", optionLabel: 'UZ - UZBEKISTAN' },
    { optionValue: "VU", optionLabel: 'VU - VANUATU' },
    { optionValue: "VE", optionLabel: 'VE - VENEZUELA, BOLIVARIAN REPUBLIC OF' },
    { optionValue: "VN", optionLabel: 'VN - VIET NAM' },
    { optionValue: "VG", optionLabel: 'VG - VIRGIN ISLANDS, BRITISH' },
    { optionValue: "VI", optionLabel: 'VI - VIRGIN ISLANDS, U.S.' },
    { optionValue: "WF", optionLabel: 'WF - WALLIS AND FUTUNA' },
    { optionValue: "EH", optionLabel: 'EH - WESTERN SAHARA' },
    { optionValue: "YE", optionLabel: 'YE - YEMEN' },
    { optionValue: "ZM", optionLabel: 'ZM - ZAMBIA' },
    { optionValue: "ZW", optionLabel: 'ZW - ZIMBABWE' }
]

export const listaPlaceOfBusiness = [
    { optionValue: "", optionLabel: '' },
    { optionValue: "AF", optionLabel:'AF - AFGHANISTAN'},
    { optionValue: "AX", optionLabel:'AX - ÅLAND ISLANDS'},
    { optionValue: "AL", optionLabel:'AL - ALBANIA'},
    { optionValue: "XG", optionLabel:'XG - ALDERNEY'},
    { optionValue: "DZ", optionLabel:'DZ - ALGERIA'},
    { optionValue: "AS", optionLabel:'AS - AMERICAN SAMOA'},
    { optionValue: "AD", optionLabel:'AD - ANDORRA'},
    { optionValue: "AO", optionLabel:'AO - ANGOLA'},
    { optionValue: "AI", optionLabel:'AI - ANGUILLA'},
    { optionValue: "AQ", optionLabel:'AQ - ANTARCTICA'},
    { optionValue: "AG", optionLabel:'AG - ANTIGUA AND BARBUDA'},
    { optionValue: "AR", optionLabel:'AR - ARGENTINA'},
    { optionValue: "AM", optionLabel:'AM - ARMENIA'},
    { optionValue: "AW", optionLabel:'AW - ARUBA'},
    { optionValue: "AU", optionLabel:'AU - AUSTRALIA'},
    { optionValue: "AZ", optionLabel:'AZ - AZERBAIJAN'},
    { optionValue: "BS", optionLabel:'BS - BAHAMAS'},
    { optionValue: "BH", optionLabel:'BH - BAHRAIN'},
    { optionValue: "BD", optionLabel:'BD - BANGLADESH'},
    { optionValue: "BB", optionLabel:'BB - BARBADOS'},
    { optionValue: "BY", optionLabel:'BY - BELARUS'},
    { optionValue: "BZ", optionLabel:'BZ - BELIZE'},
    { optionValue: "BJ", optionLabel:'BJ - BENIN'},
    { optionValue: "BM", optionLabel:'BM - BERMUDA'},
    { optionValue: "BT", optionLabel:'BT - BHUTAN'},
    { optionValue: "BO", optionLabel:'BO - BOLIVIA'},
    { optionValue: "BQ", optionLabel:'BQ - BONAIRE, SAINT EUSTATIUS AND SABA'},
    { optionValue: "BA", optionLabel:'BA - BOSNIA AND HERZEGOVINA'},
    { optionValue: "BW", optionLabel:'BW - BOTSWANA'},
    { optionValue: "BV", optionLabel:'BV - BOUVET ISLAND'},
    { optionValue: "BR", optionLabel:'BR - BRAZIL'},
    { optionValue: "IO", optionLabel:'IO - BRITISH INDIAN OCEAN TERRITORY'},
    { optionValue: "BN", optionLabel:'BN - BRUNEI DARUSSALAM'},
    { optionValue: "XB", optionLabel:'XB - BUESINGEN'},
    { optionValue: "BF", optionLabel:'BF - BURKINA FASO'},
    { optionValue: "BI", optionLabel:'BI - BURUNDI'},
    { optionValue: "KH", optionLabel:'KH - CAMBODIA'},
    { optionValue: "CM", optionLabel:'CM - CAMEROON'},
    //{ optionValue: "XD", optionLabel:"XD - CAMPIONE D'ITALIA"},
    { optionValue: "CA", optionLabel:'CA - CANADA'},
    { optionValue: "IC", optionLabel:'IC - CANARY ISLANDS'},
    { optionValue: "CV", optionLabel:'CV - CAPE VERDE'},
    { optionValue: "KY", optionLabel:'KY - CAYMAN ISLANDS'},
    { optionValue: "CF", optionLabel:'CF - CENTRAL AFRICAN REPUBLIC'},
    { optionValue: "XC", optionLabel:'XC - CEUTA'},
    { optionValue: "TD", optionLabel:'TD - CHAD'},
    { optionValue: "CL", optionLabel:'CL - CHILE'},
    { optionValue: "CN", optionLabel:'CN - CHINA'},
    { optionValue: "CX", optionLabel:'CX - CHRISTMAS ISLAND'},
    { optionValue: "CC", optionLabel:'CC - COCOS (KEELING) ISLANDS'},
    { optionValue: "CO", optionLabel:'CO - COLOMBIA'},
    { optionValue: "KM", optionLabel:'KM - COMOROS'},
    { optionValue: "CG", optionLabel:'CG - CONGO'},
    { optionValue: "CD", optionLabel:'CD - CONGO, THE DEMOCRATIC REPUBLIC OF THE'},
    { optionValue: "CK", optionLabel:'CK - COOK ISLANDS'},
    { optionValue: "CR", optionLabel:'CR - COSTA RICA'},
    { optionValue: "CI", optionLabel:"CI - COTE D'IVOIRE"},
    { optionValue: "CU", optionLabel:'CU - CUBA'},
    { optionValue: "CW", optionLabel:'CW - CURACAO'},
    { optionValue: "DJ", optionLabel:'DJ - DJIBOUTI'},
    { optionValue: "DM", optionLabel:'DM - DOMINICA'},
    { optionValue: "DO", optionLabel:'DO - DOMINICAN REPUBLIC'},
    { optionValue: "EC", optionLabel:'EC - ECUADOR'},
    { optionValue: "EG", optionLabel:'EG - EGYPT'},
    { optionValue: "SV", optionLabel:'SV - EL SALVADOR'},
    { optionValue: "GQ", optionLabel:'GQ - EQUATORIAL GUINEA'},
    { optionValue: "ER", optionLabel:'ER - ERITREA'},
    { optionValue: "ET", optionLabel:'ET - ETHIOPIA'},
    { optionValue: "FK", optionLabel:'FK - FALKLAND ISLANDS (MALVINAS)'},
    { optionValue: "FO", optionLabel:'FO - FAROE ISLANDS'},
    { optionValue: "FJ", optionLabel:'FJ - FIJI'},
    { optionValue: "GF", optionLabel:'GF - FRENCH GUIANA'},
    { optionValue: "PF", optionLabel:'PF - FRENCH POLYNESIA'},
    { optionValue: "TF", optionLabel:'TF - FRENCH SOUTHERN TERRITORIES'},
    { optionValue: "GA", optionLabel:'GA - GABON'},
    { optionValue: "GM", optionLabel:'GM - GAMBIA'},
    { optionValue: "GE", optionLabel:'GE - GEORGIA'},
    { optionValue: "GH", optionLabel:'GH - GHANA'},
    { optionValue: "GI", optionLabel:'GI - GIBRALTAR'},
    { optionValue: "GL", optionLabel:'GL - GREENLAND'},
    { optionValue: "GD", optionLabel:'GD - GRENADA'},
    { optionValue: "GP", optionLabel:'GP - GUADELOUPE'},
    { optionValue: "GU", optionLabel:'GU - GUAM'},
    { optionValue: "GT", optionLabel:'GT - GUATEMALA'},
    { optionValue: "GG", optionLabel:'GG - GUERNSEY'},
    { optionValue: "GN", optionLabel:'GN - GUINEA'},
    { optionValue: "GW", optionLabel:'GW - GUINEA-BISSAU'},
    { optionValue: "GY", optionLabel:'GY - GUYANA'},
    { optionValue: "HT", optionLabel:'HT - HAITI'},
    { optionValue: "HM", optionLabel:'HM - HEARD ISLAND AND MCDONALD ISLANDS'},
    { optionValue: "XA", optionLabel:'XA - HELIOGOLAND'},
    { optionValue: "VA", optionLabel:'VA - HOLY SEE (VATICAN CITY STATE)'},
    { optionValue: "HN", optionLabel:'HN - HONDURAS'},
    { optionValue: "HK", optionLabel:'HK - HONG KONG'},
    { optionValue: "IS", optionLabel:'IS - ICELAND'},
    { optionValue: "IN", optionLabel:'IN - INDIA'},
    { optionValue: "ID", optionLabel:'ID - INDONESIA'},
    { optionValue: "IR", optionLabel:'IR - IRAN, ISLAMIC REPUBLIC OF'},
    { optionValue: "IQ", optionLabel:'IQ - IRAQ'},
    { optionValue: "IM", optionLabel:'IM - ISLE OF MAN'},
    { optionValue: "IL", optionLabel:'IL - ISRAEL'},
    { optionValue: "JM", optionLabel:'JM - JAMAICA'},
    { optionValue: "JP", optionLabel:'JP - JAPAN'},
    { optionValue: "JE", optionLabel:'JE - JERSEY'},
    { optionValue: "JO", optionLabel:'JO - JORDAN'},
    { optionValue: "KZ", optionLabel:'KZ - KAZAKHSTAN'},
    { optionValue: "KE", optionLabel:'KE - KENYA'},
    { optionValue: "KI", optionLabel:'KI - KIRIBATI'},
    { optionValue: "KP", optionLabel:"KP - KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF"},
    { optionValue: "KR", optionLabel:'KR - KOREA, REPUBLIC OF'},
    { optionValue: "KW", optionLabel:'KW - KUWAIT'},
    { optionValue: "KG", optionLabel:'KG - KYRGYZSTAN'},
    //{ optionValue: "XE", optionLabel:'XE - LAKE LUGANO'},
    { optionValue: "LA", optionLabel:"LA - LAO PEOPLE'S DEMOCRATIC REPUBLIC"},
    { optionValue: "LB", optionLabel:'LB - LEBANON'},
    { optionValue: "LS", optionLabel:'LS - LESOTHO'},
    { optionValue: "LR", optionLabel:'LR - LIBERIA'},
    { optionValue: "LY", optionLabel:'LY - LIBYAN ARAB JAMAHIRIYA'},
    { optionValue: "LI", optionLabel:'LI - LIECHTENSTEIN'},
    //{ optionValue: "XF", optionLabel:'XF - LIVIGNO'},
    { optionValue: "MO", optionLabel:'MO - MACAO'},
    { optionValue: "MK", optionLabel:'MK - MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'},
    { optionValue: "MG", optionLabel:'MG - MADAGASCAR'},
    { optionValue: "MW", optionLabel:'MW - MALAWI'},
    { optionValue: "MY", optionLabel:'MY - MALAYSIA'},
    { optionValue: "MV", optionLabel:'MV - MALDIVES'},
    { optionValue: "ML", optionLabel:'ML - MALI'},
    { optionValue: "MH", optionLabel:'MH - MARSHALL ISLANDS'},
    { optionValue: "MQ", optionLabel:'MQ - MARTINIQUE'},
    { optionValue: "MR", optionLabel:'MR - MAURITANIA'},
    { optionValue: "MU", optionLabel:'MU - MAURITIUS'},
    { optionValue: "YT", optionLabel:'YT - MAYOTTE'},
    { optionValue: "XL", optionLabel:'XL - MELILLA'},
    { optionValue: "MX", optionLabel:'MX - MEXICO'},
    { optionValue: "FM", optionLabel:'FM - MICRONESIA, FEDERATED STATES OF'},
    { optionValue: "MD", optionLabel:'MD - MOLDOVA, REPUBLIC OF'},
    { optionValue: "MC", optionLabel:'MC - MONACO'},
    { optionValue: "MN", optionLabel:'MN - MONGOLIA'},
    { optionValue: "ME", optionLabel:'ME - MONTENEGRO'},
    { optionValue: "MS", optionLabel:'MS - MONTSERRAT'},
    { optionValue: "MA", optionLabel:'MA - MOROCCO'},
    { optionValue: "XM", optionLabel:'XM - MOUNT ATHOS'},
    { optionValue: "MZ", optionLabel:'MZ - MOZAMBIQUE'},
    { optionValue: "MM", optionLabel:'MM - MYANMAR'},
    { optionValue: "NA", optionLabel:'NA - NAMIBIA'},
    { optionValue: "NR", optionLabel:'NR - NAURU'},
    { optionValue: "NP", optionLabel:'NP - NEPAL'},
    { optionValue: "NC", optionLabel:'NC - NEW CALEDONIA'},
    { optionValue: "NZ", optionLabel:'NZ - NEW ZEALAND'},
    { optionValue: "NI", optionLabel:'NI - NICARAGUA'},
    { optionValue: "NE", optionLabel:'NE - NIGER'},
    { optionValue: "NG", optionLabel:'NG - NIGERIA'},
    { optionValue: "NU", optionLabel:'NU - NIUE'},
    { optionValue: "NF", optionLabel:'NF - NORFOLK ISLAND'},
    //{ optionValue: "XI", optionLabel:'XI - NORTHERN IRELAND'},
    { optionValue: "MP", optionLabel:'MP - NORTHERN MARIANA ISLANDS'},
    { optionValue: "NO", optionLabel:'NO - NORWAY'},
    { optionValue: "OM", optionLabel:'OM - OMAN'},
    { optionValue: "PK", optionLabel:'PK - PAKISTAN'},
    { optionValue: "PW", optionLabel:'PW - PALAU'},
    { optionValue: "PS", optionLabel:'PS - PALESTINIAN TERRITORY, OCCUPIED'},
    { optionValue: "PA", optionLabel:'PA - PANAMA'},
    { optionValue: "PG", optionLabel:'PG - PAPUA NEW GUINEA'},
    { optionValue: "PY", optionLabel:'PY - PARAGUAY'},
    { optionValue: "PE", optionLabel:'PE - PERU'},
    { optionValue: "PH", optionLabel:'PH - PHILIPPINES'},
    { optionValue: "PN", optionLabel:'PN - PITCAIRN'},
    { optionValue: "PR", optionLabel:'PR - PUERTO RICO'},
    { optionValue: "QA", optionLabel:'QA - QATAR'},
    { optionValue: "RE", optionLabel:'RE - REUNION'},
    { optionValue: "RU", optionLabel:'RU - RUSSIAN FEDERATION'},
    { optionValue: "RW", optionLabel:'RW - RWANDA'},
    { optionValue: "BL", optionLabel:'BL - SAINT BARTHÉLEMY'},
    { optionValue: "SH", optionLabel:'SH - SAINT HELENA'},
    { optionValue: "KN", optionLabel:'KN - SAINT KITTS AND NEVIS'},
    { optionValue: "LC", optionLabel:'LC - SAINT LUCIA'},
    { optionValue: "MF", optionLabel:'MF - SAINT MARTIN'},
    { optionValue: "SX", optionLabel:'SX - SAINT MARTIN (DUTCH PART)'},
    { optionValue: "PM", optionLabel:'PM - SAINT PIERRE AND MIQUELON'},
    { optionValue: "VC", optionLabel:'VC - SAINT VINCENT AND THE GRENADINES'},
    { optionValue: "WS", optionLabel:'WS - SAMOA'},
    { optionValue: "SM", optionLabel:'SM - SAN MARINO'},
    { optionValue: "ST", optionLabel:'ST - SAO TOME AND PRINCIPE'},
    { optionValue: "XH", optionLabel:'XH - SARK'},
    { optionValue: "SA", optionLabel:'SA - SAUDI ARABIA'},
    { optionValue: "SN", optionLabel:'SN - SENEGAL'},
    { optionValue: "RS", optionLabel:'RS - SERBIA'},
    { optionValue: "SC", optionLabel:'SC - SEYCHELLES'},
    { optionValue: "SL", optionLabel:'SL - SIERRA LEONE'},
    { optionValue: "SG", optionLabel:'SG - SINGAPORE'},
    { optionValue: "SB", optionLabel:'SB - SOLOMON ISLANDS'},
    { optionValue: "SO", optionLabel:'SO - SOMALIA'},
    { optionValue: "ZA", optionLabel:'ZA - SOUTH AFRICA'},
    { optionValue: "GS", optionLabel:'GS - SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'},
    { optionValue: "SS", optionLabel:'SS - SOUTH SUDAN'},
    { optionValue: "LK", optionLabel:'LK - SRI LANKA'},
    { optionValue: "SD", optionLabel:'SD - SUDAN'},
    { optionValue: "SR", optionLabel:'SR - SURINAME'},
    { optionValue: "SJ", optionLabel:'SJ - SVALBARD AND JAN MAYEN'},
    { optionValue: "SZ", optionLabel:'SZ - SWAZILAND'},
    { optionValue: "CH", optionLabel:'CH - SWITZERLAND'},
    { optionValue: "SY", optionLabel:'SY - SYRIAN ARAB REPUBLIC'},
    { optionValue: "TW", optionLabel:'TW - TAIWAN, PROVINCE OF CHINA'},
    { optionValue: "TJ", optionLabel:'TJ - TAJIKISTAN'},
    { optionValue: "TZ", optionLabel:'TZ - TANZANIA, UNITED REPUBLIC OF'},
    { optionValue: "TH", optionLabel:'TH - THAILAND'},
    { optionValue: "TL", optionLabel:'TL - TIMOR-LESTE'},
    { optionValue: "TG", optionLabel:'TG - TOGO'},
    { optionValue: "TK", optionLabel:'TK - TOKELAU'},
    { optionValue: "TO", optionLabel:'TO - TONGA'},
    { optionValue: "TT", optionLabel:'TT - TRINIDAD AND TOBAGO'},
    { optionValue: "TN", optionLabel:'TN - TUNISIA'},
    { optionValue: "TR", optionLabel:'TR - TURKEY'},
    { optionValue: "TM", optionLabel:'TM - TURKMENISTAN'},
    { optionValue: "TC", optionLabel:'TC - TURKS AND CAICOS ISLANDS'},
    { optionValue: "TV", optionLabel:'TV - TUVALU'},
    { optionValue: "UG", optionLabel:'UG - UGANDA'},
    { optionValue: "UA", optionLabel:'UA - UKRAINE'},
    { optionValue: "AE", optionLabel:'AE - UNITED ARAB EMIRATES'},
    //{ optionValue: "XU", optionLabel:'XU - UNITED KINGDOM without Northern Ireland'},
    { optionValue: "GB", optionLabel:'GB - UNITED KINGDOM'},
    { optionValue: "US", optionLabel:'US - UNITED STATES'},
    { optionValue: "UM", optionLabel:'UM - UNITED STATES MINOR OUTLYING ISLANDS'},
    { optionValue: "UY", optionLabel:'UY - URUGUAY'},
    { optionValue: "UZ", optionLabel:'UZ - UZBEKISTAN'},
    { optionValue: "VU", optionLabel:'VU - VANUATU'},
    { optionValue: "VE", optionLabel:'VE - VENEZUELA, BOLIVARIAN REPUBLIC OF'},
    { optionValue: "VN", optionLabel:'VN - VIET NAM'},
    { optionValue: "VG", optionLabel:'VG - VIRGIN ISLANDS, BRITISH'},
    { optionValue: "VI", optionLabel:'VI - VIRGIN ISLANDS, U.S.'},
    { optionValue: "WF", optionLabel:'WF - WALLIS AND FUTUNA'},
    { optionValue: "EH", optionLabel:'EH - WESTERN SAHARA'},
    { optionValue: "YE", optionLabel:'YE - YEMEN'},
    { optionValue: "ZM", optionLabel:'ZM - ZAMBIA'},
    { optionValue: "ZW", optionLabel:'ZW - ZIMBABWE'}
]

/* serve per le option Issued By dei campi per Vat Number e National Tax reference */
export const listaIssuedBy =
            [
                { optionValue: "AF", optionLabel: "AF - AFGHANISTAN" },
                { optionValue: "AX", optionLabel: "AX - ÅLAND ISLANDS" },
                { optionValue: "AL", optionLabel: "AL - ALBANIA" },
                { optionValue: "DZ", optionLabel: "DZ - ALGERIA" },
                { optionValue: "AS", optionLabel: "AS - AMERICAN SAMOA" },
                { optionValue: "AD", optionLabel: "AD - ANDORRA" },
                { optionValue: "AO", optionLabel: "AO - ANGOLA" },
                { optionValue: "AI", optionLabel: "AI - ANGUILLA" },
                { optionValue: "AQ", optionLabel: "AQ - ANTARCTICA" },
                { optionValue: "AG", optionLabel: "AG - ANTIGUA AND BARBUDA" },
                { optionValue: "AR", optionLabel: "AR - ARGENTINA" },
                { optionValue: "AM", optionLabel: "AM - ARMENIA" },
                { optionValue: "AW", optionLabel: "AW - ARUBA" },
                { optionValue: "AU", optionLabel: "AU - AUSTRALIA" },
                { optionValue: "AZ", optionLabel: "AZ - AZERBAIJAN" },
                { optionValue: "BS", optionLabel: "BS - BAHAMAS" },
                { optionValue: "BH", optionLabel: "BH - BAHRAIN" },
                { optionValue: "BD", optionLabel: "BD - BANGLADESH" },
                { optionValue: "BB", optionLabel: "BB - BARBADOS" },
                { optionValue: "BY", optionLabel: "BY - BELARUS" },
                { optionValue: "BZ", optionLabel: "BZ - BELIZE" },
                { optionValue: "BJ", optionLabel: "BJ - BENIN" },
                { optionValue: "BM", optionLabel: "BM - BERMUDA" },
                { optionValue: "BT", optionLabel: "BT - BHUTAN" },
                { optionValue: "BO", optionLabel: "BO - BOLIVIA" },
                { optionValue: "BQ", optionLabel: "BQ - BONAIRE, SAINT EUSTATIUS AND SABA" },
                { optionValue: "BA", optionLabel: "BA - BOSNIA AND HERZEGOVINA" },
                { optionValue: "BW", optionLabel: "BW - BOTSWANA" },
                { optionValue: "BV", optionLabel: "BV - BOUVET ISLAND" },
                { optionValue: "BR", optionLabel: "BR - BRAZIL" },
                { optionValue: "IO", optionLabel: "IO - BRITISH INDIAN OCEAN TERRITORY" },
                { optionValue: "BN", optionLabel: "BN - BRUNEI DARUSSALAM" },
                { optionValue: "BF", optionLabel: "BF - BURKINA FASO" },
                { optionValue: "BI", optionLabel: "BI - BURUNDI" },
                { optionValue: "KH", optionLabel: "KH - CAMBODIA" },
                { optionValue: "CM", optionLabel: "CM - CAMEROON" },
                { optionValue: "CA", optionLabel: "CA - CANADA" },
                { optionValue: "IC", optionLabel: "IC - CANARY ISLANDS" },
                { optionValue: "CV", optionLabel: "CV - CAPE VERDE" },
                { optionValue: "KY", optionLabel: "KY - CAYMAN ISLANDS" },
                { optionValue: "CF", optionLabel: "CF - CENTRAL AFRICAN REPUBLIC" },
                { optionValue: "TD", optionLabel: "TD - CHAD" },
                { optionValue: "CL", optionLabel: "CL - CHILE" },
                { optionValue: "CN", optionLabel: "CN - CHINA" },
                { optionValue: "CX", optionLabel: "CX - CHRISTMAS ISLAND" },
                { optionValue: "CC", optionLabel: "CC - COCOS (KEELING) ISLANDS" },
                { optionValue: "CO", optionLabel: "CO - COLOMBIA" },
                { optionValue: "KM", optionLabel: "KM - COMOROS" },
                { optionValue: "CG", optionLabel: "CG - CONGO" },
                { optionValue: "CD", optionLabel: "CD - CONGO, THE DEMOCRATIC REPUBLIC OF THE" },
                { optionValue: "CK", optionLabel: "CK - COOK ISLANDS" },
                { optionValue: "CR", optionLabel: "CR - COSTA RICA" },
                { optionValue: "CI", optionLabel: "CI - COTE D'IVOIRE" },
                { optionValue: "CU", optionLabel: "CU - CUBA" },
                { optionValue: "CW", optionLabel: "CW - CURACAO" },
                { optionValue: "DJ", optionLabel: "DJ - DJIBOUTI" },
                { optionValue: "DM", optionLabel: "DM - DOMINICA" },
                { optionValue: "DO", optionLabel: "DO - DOMINICAN REPUBLIC" },
                { optionValue: "EC", optionLabel: "EC - ECUADOR" },
                { optionValue: "EG", optionLabel: "EG - EGYPT" },
                { optionValue: "SV", optionLabel: "SV - EL SALVADOR" },
                { optionValue: "GQ", optionLabel: "GQ - EQUATORIAL GUINEA" },
                { optionValue: "ER", optionLabel: "ER - ERITREA" },
                { optionValue: "ET", optionLabel: "ET - ETHIOPIA" },
                { optionValue: "FK", optionLabel: "FK - FALKLAND ISLANDS (MALVINAS)" },
                { optionValue: "FO", optionLabel: "FO - FAROE ISLANDS" },
                { optionValue: "FJ", optionLabel: "FJ - FIJI" },
                { optionValue: "GF", optionLabel: "GF - FRENCH GUIANA" },
                { optionValue: "PF", optionLabel: "PF - FRENCH POLYNESIA" },
                { optionValue: "TF", optionLabel: "TF - FRENCH SOUTHERN TERRITORIES" },
                { optionValue: "GA", optionLabel: "GA - GABON" },
                { optionValue: "GM", optionLabel: "GM - GAMBIA" },
                { optionValue: "GE", optionLabel: "GE - GEORGIA" },
                { optionValue: "GH", optionLabel: "GH - GHANA" },
                { optionValue: "GI", optionLabel: "GI - GIBRALTAR" },
                { optionValue: "GL", optionLabel: "GL - GREENLAND" },
                { optionValue: "GD", optionLabel: "GD - GRENADA" },
                { optionValue: "GP", optionLabel: "GP - GUADELOUPE" },
                { optionValue: "GU", optionLabel: "GU - GUAM" },
                { optionValue: "GT", optionLabel: "GT - GUATEMALA" },
                { optionValue: "GG", optionLabel: "GG - GUERNSEY" },
                { optionValue: "GN", optionLabel: "GN - GUINEA" },
                { optionValue: "GW", optionLabel: "GW - GUINEA-BISSAU" },
                { optionValue: "GY", optionLabel: "GY - GUYANA" },
                { optionValue: "HT", optionLabel: "HT - HAITI" },
                { optionValue: "HM", optionLabel: "HM - HEARD ISLAND AND MCDONALD ISLANDS" },
                { optionValue: "VA", optionLabel: "VA - HOLY SEE (VATICAN CITY STATE)" },
                { optionValue: "HN", optionLabel: "HN - HONDURAS" },
                { optionValue: "HK", optionLabel: "HK - HONG KONG" },
                { optionValue: "IS", optionLabel: "IS - ICELAND" },
                { optionValue: "IN", optionLabel: "IN - INDIA" },
                { optionValue: "ID", optionLabel: "ID - INDONESIA" },
                { optionValue: "IR", optionLabel: "IR - IRAN, ISLAMIC REPUBLIC OF" },
                { optionValue: "IQ", optionLabel: "IQ - IRAQ" },
                { optionValue: "IM", optionLabel: "IM - ISLE OF MAN" },
                { optionValue: "IL", optionLabel: "IL - ISRAEL" },
                { optionValue: "JM", optionLabel: "JM - JAMAICA" },
                { optionValue: "JP", optionLabel: "JP - JAPAN" },
                { optionValue: "JE", optionLabel: "JE - JERSEY" },
                { optionValue: "JO", optionLabel: "JO - JORDAN" },
                { optionValue: "KZ", optionLabel: "KZ - KAZAKHSTAN" },
                { optionValue: "KE", optionLabel: "KE - KENYA" },
                { optionValue: "KI", optionLabel: "KI - KIRIBATI" },
                { optionValue: "KP", optionLabel: "KP - KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
                { optionValue: "KR", optionLabel: "KR - KOREA, REPUBLIC OF" },
                { optionValue: "KW", optionLabel: "KW - KUWAIT" },
                { optionValue: "KG", optionLabel: "KG - KYRGYZSTAN" },
                { optionValue: "LA", optionLabel: "LA - LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
                { optionValue: "LB", optionLabel: "LB - LEBANON" },
                { optionValue: "LS", optionLabel: "LS - LESOTHO" },
                { optionValue: "LR", optionLabel: "LR - LIBERIA" },
                { optionValue: "LY", optionLabel: "LY - LIBYAN ARAB JAMAHIRIYA" },
                { optionValue: "LI", optionLabel: "LI - LIECHTENSTEIN" },
                { optionValue: "MO", optionLabel: "MO - MACAO" },
                { optionValue: "MK", optionLabel: "MK - MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF" },
                { optionValue: "MG", optionLabel: "MG - MADAGASCAR" },
                { optionValue: "MW", optionLabel: "MW - MALAWI" },
                { optionValue: "MY", optionLabel: "MY - MALAYSIA" },
                { optionValue: "MV", optionLabel: "MV - MALDIVES" },
                { optionValue: "ML", optionLabel: "ML - MALI" },
                { optionValue: "MH", optionLabel: "MH - MARSHALL ISLANDS" },
                { optionValue: "MQ", optionLabel: "MQ - MARTINIQUE" },
                { optionValue: "MR", optionLabel: "MR - MAURITANIA" },
                { optionValue: "MU", optionLabel: "MU - MAURITIUS" },
                { optionValue: "YT", optionLabel: "YT - MAYOTTE" },
                { optionValue: "MX", optionLabel: "MX - MEXICO" },
                { optionValue: "FM", optionLabel: "FM - MICRONESIA, FEDERATED STATES OF" },
                { optionValue: "MD", optionLabel: "MD - MOLDOVA, REPUBLIC OF" },
                { optionValue: "MC", optionLabel: "MC - MONACO" },
                { optionValue: "MN", optionLabel: "MN - MONGOLIA" },
                { optionValue: "ME", optionLabel: "ME - MONTENEGRO" },
                { optionValue: "MS", optionLabel: "MS - MONTSERRAT" },
                { optionValue: "MA", optionLabel: "MA - MOROCCO" },
                { optionValue: "MZ", optionLabel: "MZ - MOZAMBIQUE" },
                { optionValue: "MM", optionLabel: "MM - MYANMAR" },
                { optionValue: "NA", optionLabel: "NA - NAMIBIA" },
                { optionValue: "NR", optionLabel: "NR - NAURU" },
                { optionValue: "NP", optionLabel: "NP - NEPAL" },
                { optionValue: "NC", optionLabel: "NC - NEW CALEDONIA" },
                { optionValue: "NZ", optionLabel: "NZ - NEW ZEALAND" },
                { optionValue: "NI", optionLabel: "NI - NICARAGUA" },
                { optionValue: "NE", optionLabel: "NE - NIGER" },
                { optionValue: "NG", optionLabel: "NG - NIGERIA" },
                { optionValue: "NU", optionLabel: "NU - NIUE" },
                { optionValue: "NF", optionLabel: "NF - NORFOLK ISLAND" },
                { optionValue: "MP", optionLabel: "MP - NORTHERN MARIANA ISLANDS" },
                { optionValue: "NO", optionLabel: "NO - NORWAY" },
                { optionValue: "OM", optionLabel: "OM - OMAN" },
                { optionValue: "PK", optionLabel: "PK - PAKISTAN" },
                { optionValue: "PW", optionLabel: "PW - PALAU" },
                { optionValue: "PS", optionLabel: "PS - PALESTINIAN TERRITORY, OCCUPIED" },
                { optionValue: "PA", optionLabel: "PA - PANAMA" },
                { optionValue: "PG", optionLabel: "PG - PAPUA NEW GUINEA" },
                { optionValue: "PY", optionLabel: "PY - PARAGUAY" },
                { optionValue: "PE", optionLabel: "PE - PERU" },
                { optionValue: "PH", optionLabel: "PH - PHILIPPINES" },
                { optionValue: "PN", optionLabel: "PN - PITCAIRN" },
                { optionValue: "PR", optionLabel: "PR - PUERTO RICO" },
                { optionValue: "QA", optionLabel: "QA - QATAR" },
                { optionValue: "RE", optionLabel: "RE - REUNION" },
                { optionValue: "RU", optionLabel: "RU - RUSSIAN FEDERATION" },
                { optionValue: "RW", optionLabel: "RW - RWANDA" },
                { optionValue: "BL", optionLabel: "BL - SAINT BARTHÉLEMY" },
                { optionValue: "SH", optionLabel: "SH - SAINT HELENA" },
                { optionValue: "KN", optionLabel: "KN - SAINT KITTS AND NEVIS" },
                { optionValue: "LC", optionLabel: "LC - SAINT LUCIA" },
                { optionValue: "MF", optionLabel: "MF - SAINT MARTIN" },
                { optionValue: "SX", optionLabel: "SX - SAINT MARTIN (DUTCH PART)" },
                { optionValue: "PM", optionLabel: "PM - SAINT PIERRE AND MIQUELON" },
                { optionValue: "VC", optionLabel: "VC - SAINT VINCENT AND THE GRENADINES" },
                { optionValue: "WS", optionLabel: "WS - SAMOA" },
                { optionValue: "SM", optionLabel: "SM - SAN MARINO" },
                { optionValue: "ST", optionLabel: "ST - SAO TOME AND PRINCIPE" },
                { optionValue: "SA", optionLabel: "SA - SAUDI ARABIA" },
                { optionValue: "SN", optionLabel: "SN - SENEGAL" },
                { optionValue: "RS", optionLabel: "RS - SERBIA" },
                { optionValue: "SC", optionLabel: "SC - SEYCHELLES" },
                { optionValue: "SL", optionLabel: "SL - SIERRA LEONE" },
                { optionValue: "SG", optionLabel: "SG - SINGAPORE" },
                { optionValue: "SB", optionLabel: "SB - SOLOMON ISLANDS" },
                { optionValue: "SO", optionLabel: "SO - SOMALIA" },
                { optionValue: "ZA", optionLabel: "ZA - SOUTH AFRICA" },
                { optionValue: "GS", optionLabel: "GS - SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS" },
                { optionValue: "SS", optionLabel: "SS - SOUTH SUDAN" },
                { optionValue: "LK", optionLabel: "LK - SRI LANKA" },
                { optionValue: "SD", optionLabel: "SD - SUDAN" },
                { optionValue: "SR", optionLabel: "SR - SURINAME" },
                { optionValue: "SJ", optionLabel: "SJ - SVALBARD AND JAN MAYEN" },
                { optionValue: "SZ", optionLabel: "SZ - SWAZILAND" },
                { optionValue: "CH", optionLabel: "CH - SWITZERLAND" },
                { optionValue: "SY", optionLabel: "SY - SYRIAN ARAB REPUBLIC" },
                { optionValue: "TW", optionLabel: "TW - TAIWAN, PROVINCE OF CHINA" },
                { optionValue: "TJ", optionLabel: "TJ - TAJIKISTAN" },
                { optionValue: "TZ", optionLabel: "TZ - TANZANIA, UNITED REPUBLIC OF" },
                { optionValue: "TH", optionLabel: "TH - THAILAND" },
                { optionValue: "TL", optionLabel: "TL - TIMOR-LESTE" },
                { optionValue: "TG", optionLabel: "TG - TOGO" },
                { optionValue: "TK", optionLabel: "TK - TOKELAU" },
                { optionValue: "TO", optionLabel: "TO - TONGA" },
                { optionValue: "TT", optionLabel: "TT - TRINIDAD AND TOBAGO" },
                { optionValue: "TN", optionLabel: "TN - TUNISIA" },
                { optionValue: "TR", optionLabel: "TR - TURKEY" },
                { optionValue: "TM", optionLabel: "TM - TURKMENISTAN" },
                { optionValue: "TC", optionLabel: "TC - TURKS AND CAICOS ISLANDS" },
                { optionValue: "TV", optionLabel: "TV - TUVALU" },
                { optionValue: "UG", optionLabel: "UG - UGANDA" },
                { optionValue: "UA", optionLabel: "UA - UKRAINE" },
                { optionValue: "AE", optionLabel: "AE - UNITED ARAB EMIRATES" },
                { optionValue: "GB", optionLabel: "GB - UNITED KINGDOM" },
                { optionValue: "US", optionLabel: "US - UNITED STATES" },
                { optionValue: "UM", optionLabel: "UM - UNITED STATES MINOR OUTLYING ISLANDS" },
                { optionValue: "UY", optionLabel: "UY - URUGUAY" },
                { optionValue: "UZ", optionLabel: "UZ - UZBEKISTAN" },
                { optionValue: "VU", optionLabel: "VU - VANUATU" },
                { optionValue: "VE", optionLabel: "VE - VENEZUELA, BOLIVARIAN REPUBLIC OF" },
                { optionValue: "VN", optionLabel: "VN - VIET NAM" },
                { optionValue: "VG", optionLabel: "VG - VIRGIN ISLANDS, BRITISH" },
                { optionValue: "VI", optionLabel: "VI - VIRGIN ISLANDS, U.S." },
                { optionValue: "WF", optionLabel: "WF - WALLIS AND FUTUNA" },
                { optionValue: "EH", optionLabel: "EH - WESTERN SAHARA" },
                { optionValue: "YE", optionLabel: "YE - YEMEN" },
                { optionValue: "ZM", optionLabel: "ZM - ZAMBIA" },
                { optionValue: "ZW", optionLabel: "ZW - ZIMBABWE" }
]
